var An = Object.defineProperty;
var yn = (e, n, a) => n in e ? An(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var C = (e, n, a) => yn(e, typeof n != "symbol" ? n + "" : n, a);
import { ConversationContext as Z, HostContext as ze, useStateChangeCallbacks as zn, WorkItemContext as Je, setVersionInfo as xn } from "@buzzeasy/shared-frontend-utilities";
import { jsx as t, jsxs as c, Fragment as M } from "react/jsx-runtime";
import Nn, { createContext as en, useMemo as X, useEffect as L, useState as V, useRef as Re, useCallback as j, useContext as A } from "react";
import { useDispatch as $n, useSelector as U, Provider as Sn } from "react-redux";
import { styled as p, css as te, createGlobalStyle as Dn, ThemeProvider as Rn } from "styled-components";
import { HubConnectionState as le, HubConnectionBuilder as Hn } from "@microsoft/signalr";
import { initReactI18next as nn, useTranslation as E, I18nextProvider as On } from "react-i18next";
import { Button as R, Space as F, theme as tn, ConfigProvider as an, Dropdown as jn, Input as In, Spin as Fn, Avatar as Mn, Radio as fe, Switch as Pn, Alert as Bn } from "antd";
import { createSlice as Ie, configureStore as Un, nanoid as Xn } from "@reduxjs/toolkit";
import { createApi as Fe, fetchBaseQuery as Wn } from "@reduxjs/toolkit/query/react";
import { fetchBaseQuery as En } from "@reduxjs/toolkit/dist/query";
import { createApi as Ln } from "@reduxjs/toolkit/dist/query/react";
import on from "jwt-decode";
import rn from "i18next";
import { UserAgent as Gn } from "sip.js/lib/api/user-agent";
import { SimpleUser as qn } from "sip.js/lib/platform/web";
import Ce from "moment";
import Vn from "moment-duration-format";
import ln, { RightOutlined as sn, CustomerServiceOutlined as we, InboxOutlined as He, MobileOutlined as Kn, PhoneOutlined as Qn, CheckOutlined as Zn, UserOutlined as Yn, UsergroupAddOutlined as Jn, UserAddOutlined as et, UserSwitchOutlined as nt, PauseCircleOutlined as We, AudioMutedOutlined as tt, AudioOutlined as it, ArrowRightOutlined as at } from "@ant-design/icons";
import P from "antd/es/typography/Text";
import ot from "@buzzeasy/directory-fragment";
import Ae from "antd/es/typography/Title";
const se = en(void 0);
function rt(e) {
  const n = X(
    () => ({
      ...e,
      children: void 0
    }),
    [e]
  );
  return /* @__PURE__ */ t(se.Provider, { value: n, children: e.children });
}
function cn(e, { getState: n }) {
  const a = n().configuration.token || "not_initialized";
  return e.set("authorization", `Bearer ${a}`), e;
}
function xe(e) {
  return async (n, a, i) => {
    const r = a.getState().configuration.apiBaseUrl;
    return En({ baseUrl: r + e, prepareHeaders: cn })(n, a, i);
  };
}
function lt(e, n) {
  const a = n.map((r) => `ObjectId('${r}')`).join(","), i = `{${e}:{$in:[${a}]}}`;
  return `filterExpression=${encodeURIComponent(i)}`;
}
const be = Fe({
  reducerPath: "customerManagerApi",
  tagTypes: [],
  baseQuery: xe("/customer-manager"),
  endpoints: (e) => ({
    getCustomerById: e.query({
      query: (n) => `/v3/Customers/${n}`
    })
  })
}), {
  useGetCustomerByIdQuery: st
} = be, ke = Ln({
  reducerPath: "directoryServiceApi",
  tagTypes: [],
  baseQuery: xe("/directory"),
  endpoints: (e) => ({
    getExternalContactById: e.query({
      query: (n) => `/ExternalContacts/${n}?providerNo=0`
    })
  })
}), {
  useGetExternalContactByIdQuery: ct
} = ke, Te = Fe({
  reducerPath: "recordingApi",
  tagTypes: ["Recording"],
  baseQuery: xe("/recording"),
  endpoints: (e) => ({
    getRecordingSetting: e.query({
      query: ({ conversationId: n, businessUnitId: a }) => `/conversations/${n}?businessUnitId=${a ?? ""}`,
      providesTags: ["Recording"]
    }),
    setRecordingStateForConversation: e.mutation({
      query: ({ conversationId: n, isEnabled: a }) => ({
        url: `/conversations/${n}/?value=${a}`,
        method: "POST"
      }),
      invalidatesTags: ["Recording"]
    })
  })
}), {
  useGetRecordingSettingQuery: dt,
  useSetRecordingStateForConversationMutation: ut
} = Te, _e = Fe({
  reducerPath: "userManagerApi",
  tagTypes: [],
  baseQuery: xe("/usermanager/v2"),
  endpoints: (e) => ({
    getUsersByIds: e.query({
      queryFn: (n, a, i) => {
        const { apiBaseUrl: r, tenantId: s } = a.getState().configuration, l = r.startsWith("https://api-dev.geomant.cloud") ? "https://api-qa.geomant.cloud" : r;
        return Wn({ baseUrl: l + "/usermanager/v2", prepareHeaders: cn })(`tenant/${s}/users?${lt("_id", n)}`, a, i);
      }
    })
  })
}), {
  useGetUsersByIdsQuery: pt
} = _e;
var z = /* @__PURE__ */ ((e) => (e.DropCall = "DropCall", e.HoldCall = "HoldCall", e.UnholdCall = "UnholdCall", e.Conference = "Conference", e.Transfer = "Transfer", e.CompleteTransfer = "CompleteTransfer", e.CompleteConference = "CompleteConference", e.Mute = "Mute", e.Unmute = "Unmute", e.BargeIn = "BargeIn", e.Whisper = "Whisper", e.Monitor = "Monitor", e.DTMF = "DTMF", e))(z || {}), x = /* @__PURE__ */ ((e) => (e.Customer = "Customer", e.Agent = "Agent", e.Supervisor = "Supervisor", e.External = "External", e))(x || {}), W = /* @__PURE__ */ ((e) => (e.Active = "Active", e.Hold = "Hold", e.Muted = "Muted", e.Inviting = "Inviting", e))(W || {}), de = /* @__PURE__ */ ((e) => (e.Monitor = "Monitor", e.Whisper = "Whisper", e.BargeIn = "BargeIn", e))(de || {});
const ht = {
  calls: [],
  knownCallIds: [],
  ownResourceId: ""
};
function Oe(e, n, a) {
  const i = e.participants.find((h) => h.resourceId === n), r = e.participants.find((h) => h.participantType === x.Customer), s = e.participants.filter((h) => h.resourceId !== n).some((h) => h.state !== W.Inviting), l = e.participants.filter((h) => h.participantType !== x.Supervisor).length > 2;
  if (!i)
    return [];
  const o = [z.DropCall];
  if (l || o.push(z.DTMF), !s)
    return o;
  if (a === 1 && !l && o.push(z.Transfer, z.Conference), i.state === W.Hold && o.push(z.UnholdCall), (i.state === W.Active || i.state === W.Muted) && (l || o.push(z.HoldCall), a > 1 && !r && o.push(z.CompleteTransfer, z.CompleteConference), i.state === W.Muted ? o.push(z.Unmute) : o.push(z.Mute)), i.participantType === x.Supervisor && i.supervisorState)
    switch (i.supervisorState) {
      case de.Monitor:
        o.push(z.BargeIn, z.Whisper);
        break;
      case de.Whisper:
        o.push(z.BargeIn, z.Monitor);
        break;
      case de.BargeIn:
        o.push(z.Whisper, z.Monitor);
        break;
    }
  return o;
}
function re(e, n) {
  const a = e.filter((i) => i.participants.some((r) => r.resourceId === n)).length;
  return e.map((i) => ({ ...i, capabilities: Oe(i, n, a) }));
}
function Ee(e, n, a) {
  return e.map((i) => i.id === n ? {
    ...i,
    participants: i.participants.filter((r) => r.id !== a)
  } : i);
}
const dn = Ie({
  initialState: ht,
  name: "calls",
  reducers: {
    callsChanged: (e, { payload: n }) => {
      e.calls = re(n, e.ownResourceId);
      const a = n.map((i) => i.id).filter((i) => !e.knownCallIds.includes(i));
      e.knownCallIds = e.knownCallIds.concat(a);
    },
    participantAdded: (e, { payload: n }) => {
      var i;
      const a = Ee(e.calls, n.conversationId, n.id);
      (i = a.find((r) => r.id === n.conversationId)) == null || i.participants.push(n), e.calls = re(a, e.ownResourceId);
    },
    participantRemoved: (e, { payload: n }) => {
      const a = Ee(e.calls, n.conversationId, n.id);
      e.calls = re(a, e.ownResourceId);
    },
    participantStatusChanged: (e, { payload: n }) => {
      var i;
      const a = (i = e.calls.find((r) => r.id === n.conversationId)) == null ? void 0 : i.participants.find((r) => r.id === n.participantId);
      a && (a.state = n.newStatus, a.supervisorState = n.newSupervisorState, a.joinedAt = n.joinedAt, e.calls = re(e.calls, e.ownResourceId));
    },
    setOwnResourceId: (e, { payload: n }) => {
      e.ownResourceId = n;
    },
    callStateChanged: (e, { payload: n }) => {
      const a = e.calls.filter((l) => l.participants.some((o) => o.resourceId === e.ownResourceId)).length;
      if (!e.calls.some((l) => l.id === n.id)) {
        e.knownCallIds = e.knownCallIds.concat(n.id);
        const l = { ...n, capabilities: Oe(n, e.ownResourceId, a) }, o = [...e.calls, l];
        e.calls = re(o, e.ownResourceId);
      }
      const r = { ...n, capabilities: Oe(n, e.ownResourceId, a) }, s = e.calls.map((l) => l.id === r.id ? r : l);
      e.calls = re(s, e.ownResourceId);
    },
    callEnded: (e, { payload: n }) => {
      e.calls = e.calls.filter((a) => a.id !== n);
    }
  }
}), { participantAdded: mt, participantRemoved: gt, participantStatusChanged: vt, callsChanged: ft, setOwnResourceId: Ct, callStateChanged: bt, callEnded: kt } = dn.actions, Tt = dn.reducer, _t = {
  apiBaseUrl: "",
  token: "",
  tenantId: ""
}, un = Ie({
  name: "configuration",
  initialState: _t,
  reducers: {
    setApiUrl: (e, { payload: n }) => ({ ...e, apiBaseUrl: n }),
    setToken: (e, { payload: n }) => ({ ...e, token: n, tenantId: on(n).tenant })
  }
}), {
  setApiUrl: wt,
  setToken: At
} = un.actions, yt = un.reducer, zt = {
  hubConnectionState: le.Disconnected
}, pn = Ie({
  initialState: zt,
  name: "signalR",
  reducers: {
    setHubConnectionState: (e, n) => {
      e.hubConnectionState = n.payload;
    }
  }
}), { setHubConnectionState: xt } = pn.actions, Nt = pn.reducer, $t = Un({
  reducer: {
    configuration: yt,
    callsReducer: Tt,
    signalRReducer: Nt,
    [Te.reducerPath]: Te.reducer,
    [be.reducerPath]: be.reducer,
    [_e.reducerPath]: _e.reducer,
    [ke.reducerPath]: ke.reducer
  },
  middleware: (e) => e().concat(
    Te.middleware,
    be.middleware,
    _e.middleware,
    ke.middleware
  )
}), hn = () => $n();
class St {
  constructor() {
    C(this, "connection");
    C(this, "dispatch");
    C(this, "isInitialized", !1);
    C(this, "token", "missing_access_token");
    C(this, "apiBaseUrl", "missing_api_base_url");
    C(this, "errorHandler");
    C(this, "start", (n, a, i) => {
      this.apiBaseUrl = a;
      const r = this.apiBaseUrl + "/sipconnector/hubs/agenthub";
      if (this.token = n, this.isInitialized)
        this.dispatchConnectionState;
      else {
        this.dispatch = i;
        const s = on(n).sub ?? "";
        i(Ct(s)), this.connection = new Hn().withAutomaticReconnect().withUrl(r, { accessTokenFactory: () => this.token }).build(), this.connection.on("ParticipantAdded", this.handleParticipantAdded), this.connection.on("ParticipantRemoved", this.handleParticipantRemoved), this.connection.on("ParticipantStatusChanged", this.handleParticipantStatusChanged), this.connection.on("SendConversationStatus", this.handleCallsChanged), this.connection.on("CommandFailure", (l) => {
          this.errorHandler && this.errorHandler(l);
        }), this.connection.on("RequestRefresh", (l) => this.peek(l)), this.connection.on("ConversationStateChanged", this.handleCallStateChanged), this.connection.on("ConversationEnded", this.handleConversationEnded), this.connection.onreconnecting(this.dispatchConnectionState), this.connection.onreconnected(this.dispatchConnectionState), this.connection.onclose(this.dispatchConnectionState), this.connection.start().then(this.dispatchConnectionState).catch(this.dispatchConnectionState), this.isInitialized = !0;
      }
    });
    C(this, "onError", (n) => {
      this.errorHandler = n;
    });
    C(this, "peek", (n) => {
      this.sendMessage("Peek", n);
    });
    C(this, "hold", (n) => {
      var a;
      (a = this.connection) == null || a.invoke("Hold", n);
    });
    C(this, "unhold", (n) => {
      this.sendMessage("Unhold", n);
    });
    C(this, "mute", (n) => {
      this.sendMessage("Mute", n);
    });
    C(this, "unmute", (n) => {
      this.sendMessage("Unmute", n);
    });
    C(this, "drop", (n) => {
      this.sendMessage("Drop", n);
    });
    C(this, "transferTo", (n) => {
      this.sendMessage("TransferTo", n);
    });
    C(this, "completeConsult", (n) => {
      this.sendMessage("CompleteConsult", n);
    });
    C(this, "consultWith", (n) => {
      var a;
      return (a = this.invokeMethod("ConsultWith", n)) == null ? void 0 : a.then((i) => {
        if (i.isSuccess)
          return i.conversationId;
        this.errorHandler && this.errorHandler({
          conversationId: "",
          errorType: i.errorType,
          reasonCode: i.reasonCode
        });
      });
    });
    C(this, "playTouchTone", (n) => {
      this.sendMessage("PlayTouchTone", n);
    });
    C(this, "monitor", (n) => {
      this.sendMessage("Monitor", n);
    });
    C(this, "whisper", (n) => {
      this.sendMessage("Whisper", n);
    });
    C(this, "bargeIn", (n) => {
      this.sendMessage("BargeIn", n);
    });
    C(this, "handleParticipantAdded", (n) => {
      this.dispatch && this.dispatch(mt(n));
    });
    C(this, "handleParticipantRemoved", (n) => {
      this.dispatch && this.dispatch(gt(n));
    });
    C(this, "handleParticipantStatusChanged", (n) => {
      this.dispatch && this.dispatch(vt(n));
    });
    C(this, "handleCallsChanged", (n) => {
      this.dispatch && this.dispatch(ft(n));
    });
    C(this, "handleCallStateChanged", (n) => {
      this.dispatch && this.dispatch(bt(n));
    });
    C(this, "handleConversationEnded", (n) => {
      this.dispatch && this.dispatch(kt(n));
    });
    C(this, "dispatchConnectionState", () => {
      this.dispatch && this.connection && this.dispatch(xt(this.connection.state));
    });
  }
  sendMessage(n, ...a) {
    var i, r;
    ((i = this.connection) == null ? void 0 : i.state) === le.Connected ? (r = this.connection) == null || r.send(n, ...a) : console.error("CallHub is not in the connected state");
  }
  invokeMethod(n, ...a) {
    var i, r;
    if (((i = this.connection) == null ? void 0 : i.state) === le.Connected)
      return (r = this.connection) == null ? void 0 : r.invoke(n, ...a);
    console.error("CallHub is not in the connected state");
  }
}
const je = new St(), ie = en(void 0), Dt = ({ token: e, apiBaseUrl: n, children: a }) => {
  const i = hn();
  return L(
    () => {
      je.start(e, n, i);
    },
    [n, i, e]
  ), /* @__PURE__ */ t(ie.Provider, { value: je, children: a });
}, Me = (e) => e.signalRReducer.hubConnectionState, Ne = (e) => (n) => n.callsReducer.calls.find((a) => a.id === e), mn = (e) => e.callsReducer.calls, Pe = (e) => e.callsReducer.ownResourceId, Be = (e) => e.callsReducer.knownCallIds, Rt = "./schema.json", Ht = {
  callControl: "Call Control",
  header: {
    collapseTitle: "Anruf reduzieren",
    expandTitle: "Anruf erweitern"
  },
  callType: {
    _Call: "Anruf",
    _Conference: "Konferenz",
    _Consultation: "Rückfrage",
    _Transfer: " Transfer",
    _Outbound: "Outbound"
  },
  actions: {
    btnTooltips: {
      _Mute: "Stummschalten",
      _Unmute: "Stummschalten deaktivieren",
      _Hold: "Halten",
      _Unhold: "Halten deaktivieren",
      _AddToCall: "Zum Anruf hinzufügen",
      _OpenDialpad: "Nummernblock öffnen",
      closeDialpad: "Nummernblock schließen",
      _OpenDirectory: "Verzeichnis öffnen",
      closeDirectory: "Verzeichnis schließen",
      _Transfer: "Anruf weiterleiten",
      drop: "Auflegen",
      accept: "Annehmen"
    },
    btnTitles: {
      _Hold: "Halten",
      _Mute: "Stummschalten",
      _AddToCall: "Hinzufügen",
      _OpenDialpad: "Nummernblock",
      _OpenDirectory: "Verzeichnis",
      _Transfer: "Transfer",
      consult: "Rückfrage"
    },
    supervisorActionBtnTexts: {
      monitor: "Monitor",
      whisper: "Flüstern",
      bargeIn: "Teilnehmen"
    }
  },
  call: {
    inboundCall: "Inbound-Anruf",
    activeCall: "Aktiver Anruf",
    callOnHold: "Anruf auf Halten",
    onHold: "Auf Halten",
    recording: "Aufzeichnung",
    recordingToggle: "Aufzeichnung",
    ended: "Anruf beendet",
    calling: "Wählen..."
  },
  preview: {
    incomingX: "{{value}} eingehend",
    initiating: "Outbound startend...",
    waitTimeText: "Kundenwartezeit"
  },
  dialOut: {
    label: "Wählen",
    placeHolder: "Benutze den Nummernblock für die Eingabe",
    phoneNumber: "Telefonnummer"
  },
  misc: {
    andOthers: "& andere",
    channelNameX: "Kanalname: {{value}}",
    queueNameX: "Name der Warteschlange: {{value}}",
    unknownQueue: "Unbekannte Warteschlange",
    unknownChannel: "Unbekannter Kanal",
    unknownAgent: "Unbekannter Agent",
    unknownCustomer: "Unbekannter Kunde",
    unknownSupervisor: "Unbekannter Supervisor",
    unknownParticipant: "Unbekannter Teilnehmer",
    unknownPhone: "Unbekannte Nummer",
    initMonitoringCall: "Monitoring gestartet"
  },
  failure: {
    title: {
      _MakeCallFailed: "Anruf ist fehlgeschlagen",
      _DropFailed: "Auflegen ist fehlgeschlagen",
      _HoldFailed: "Halten ist fehlgeschlagen",
      _ResumeFailed: "Zurückholen ist fehlgeschlagen",
      _TransferFailed: "Transfer ist fehlgeschlagen",
      _ConsultFailed: "Rückfrage ist fehlgeschlagen",
      _ChangeStateFailed: "Statusänderung vom Supervisor ist fehlgeschlagen",
      _StartFailed: "Anruf konnte nicht gestartet werden"
    },
    details: {
      _ConfigurationError: "Ungültige Kanalkonfiguration",
      _AgentNotAvailable: "Der Agent ist nicht verfügbar",
      _CapacityReached: "Maximale Kapazität erreicht",
      _AgentNumberNotAvailable: "Deine Telefonnummer ist nicht konfiguriert",
      _DestinationAgentNumberNotAvailable: "Agentennummer ist nicht verfügbar",
      _DestinationNumberNotAvailable: "Telefonnummer ist nicht verfügbar",
      _GenericUnspecified: "Unerwarteter Fehler",
      _WhisperDisabled: "Silent Monitoring ist nicht möglich",
      _NumberRestricted: "Gesperrte Telefonnummer"
    }
  },
  notifications: {
    newConversation: {
      title: "Eingehender Anruf",
      description: {
        fromXCustomerPhoneOnXChannel: "Von {{phone}} auf {{channel}}.",
        acceptToAvoidRona: "Akzeptieren Sie diese Aufgabe jetzt, um eine Versetzung in die RONA-Pause zu vermeiden."
      },
      btnTexts: {
        accept: "Akzeptieren",
        decline: "Ablehnen",
        goToTask: "Zur Aufgabe gehen",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Verbindung zum Benutzer fehlgeschlagen",
        configFailed: "Abrufen der Sprachkonfiguration fehlgeschlagen",
        phoneUnregistered: "Die Registrierung der Telefonnummer ist verloren gegangen",
        phoneReregistered: "Rufnummer wurde neu registriert",
        serverDisconnected: "Die Verbindung zum Sprachserver wurde unterbrochen",
        serverReconnected: "Verbindung zum Sprachserver wird wiederhergestellt"
      },
      description: {
        reconnectSuggestion: "Wir versuchen, die Verbindung wiederherzustellen, aber Sie können versuchen, die Seite zu aktualisieren, indem Sie auf die folgende Schaltfläche klicken"
      },
      refreshBtnText: "Seite aktualisieren"
    }
  }
}, Ot = {
  $schema: Rt,
  translation: Ht
}, jt = {
  callControl: "Call Control",
  header: {
    collapseTitle: "Collapse Call",
    expandTitle: "Expand Call"
  },
  callType: {
    _Call: "Call",
    _Conference: "Conference Call",
    _Consultation: "Consultation Call",
    _Transfer: " Call Transfer",
    _Outbound: "Outbound Call"
  },
  actions: {
    btnTooltips: {
      _Mute: "Mute call",
      _Unmute: "Unmute call",
      _Hold: "Put call on hold",
      _Unhold: "Release from hold",
      _AddToCall: "Add to call",
      _OpenDialpad: "Open Dialpad",
      closeDialpad: "Close Dialpad",
      _OpenDirectory: "Open Directory",
      closeDirectory: "Close Directory",
      _Transfer: "Transfer call",
      drop: "Drop call",
      accept: "Answer call"
    },
    btnTitles: {
      _Hold: "Hold",
      _Mute: "Mute",
      _AddToCall: "Add to call",
      _OpenDialpad: "Dialpad",
      _OpenDirectory: "Directory",
      _Transfer: "Transfer",
      consult: "Consult"
    },
    supervisorActionBtnTexts: {
      monitor: "Monitor",
      whisper: "Whisper",
      bargeIn: "Barge in"
    }
  },
  call: {
    inboundCall: "Inbound Call",
    activeCall: "Active Call",
    callOnHold: "Call on hold",
    onHold: "On Hold",
    recording: "Call recording",
    recordingToggle: "Recording Toggle",
    ended: "Call ended.",
    calling: "Calling..."
  },
  preview: {
    incomingX: "Incoming {{value}}",
    initiating: "Initiating outbound call...",
    waitTimeText: "Customer wait time"
  },
  dialOut: {
    label: "Dial Out",
    placeHolder: "Use keyboard for input",
    phoneNumber: "Phone number"
  },
  misc: {
    andOthers: "& others",
    channelNameX: "Channel name: {{value}}",
    queueNameX: "Queue name: {{value}}",
    unknownQueue: "Unknown Queue",
    unknownChannel: "Unknown channel",
    unknownAgent: "Unknown Agent",
    unknownCustomer: "Unknown Customer",
    unknownSupervisor: "Unknown Supervisor",
    unknownParticipant: "Unknown Participant",
    unknownPhone: "Unknown Number",
    initMonitoringCall: "Initiating monitoring call..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Failed to initiate the call",
      _DropFailed: "Drop call failed",
      _HoldFailed: "Hold call failed",
      _ResumeFailed: "Resume call failed",
      _TransferFailed: "Failed to transfer the call",
      _ConsultFailed: "Failed to initiate the consultation call",
      _ChangeStateFailed: "Failed to change supervisor state",
      _StartFailed: "Failed to start the call"
    },
    details: {
      _ConfigurationError: "Invalid channel configuration",
      _AgentNotAvailable: "The agent is not available right now",
      _CapacityReached: "Maximum capacity reached",
      _AgentNumberNotAvailable: "Your phone number is not configured",
      _DestinationAgentNumberNotAvailable: "Destination agent's phone number is not available",
      _DestinationNumberNotAvailable: "Destination phone number is not available",
      _GenericUnspecified: "Unexpected error",
      _WhisperDisabled: "Unable to whisper in conference",
      _NumberRestricted: "Restricted phone number"
    }
  },
  notifications: {
    newConversation: {
      title: "Incoming call",
      description: {
        fromXCustomerPhoneOnXChannel: "From {{phone}} on {{channel}}.",
        acceptToAvoidRona: "Accept this task now to avoid being moved to RONA break."
      },
      btnTexts: {
        accept: "Accept",
        decline: "Decline",
        goToTask: "Go to Task",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Failed to connect user",
        configFailed: "Failed to get voice configuration",
        phoneUnregistered: "Phone number registration has been lost",
        phoneReregistered: "Phone number has been re-registered",
        serverDisconnected: "Connection to voice server has been lost",
        serverReconnected: "Connection to voice server is restored"
      },
      description: {
        reconnectSuggestion: "We are trying to reconnect, but you can try to refresh the page by clicking the button below"
      },
      refreshBtnText: "Refresh page"
    }
  }
}, It = {
  translation: jt
}, Ft = "./schema.json", Mt = {
  callControl: "Control de llamadas",
  header: {
    collapseTitle: "Contraer llamada",
    expandTitle: "expandir título Ampliar llamada"
  },
  callType: {
    _Call: "llama",
    _Conference: "llamada de conferencia",
    _Consultation: "llamada de consulta",
    _Transfer: "transferencia de llamadas",
    _Outbound: "llamada saliente"
  },
  actions: {
    btnTooltips: {
      _Mute: "Silenciar llamada",
      _Unmute: "Activar llamada",
      _Hold: "Poner llamada en espera",
      _Unhold: "Liberar de retención",
      _AddToCall: "Añadir a la convocatoria",
      _OpenDialpad: "Abrir teclado de marcación",
      closeDialpad: "Cerrar teclado de marcación",
      _OpenDirectory: "Abrir directorio",
      closeDirectory: "Cerrar Directorio",
      _Transfer: "Transferir llamada",
      drop: "Cerrar llamada",
      accept: "Responder llamada"
    },
    btnTitles: {
      _Hold: "Espera",
      _Mute: "Silenciar",
      _AddToCall: "Añadir a la convocatoria",
      _OpenDialpad: "Teclado",
      _OpenDirectory: "Directorio",
      _Transfer: "Transferir",
      consult: "Consultar"
    },
    supervisorActionBtnTexts: {
      monitor: "Monitorear",
      whisper: "Susurro",
      bargeIn: "Irrumpir"
    }
  },
  call: {
    inboundCall: "Llamada entrante",
    activeCall: "Llamada activa",
    callOnHold: "Llamada en espera",
    onHold: "En espera",
    recording: "grabación Grabación de llamadas",
    recordingToggle: "Alternar grabación",
    ended: "Llamada finalizada",
    calling: "Llamando"
  },
  preview: {
    incomingX: "Entrante X",
    initiating: "Iniciando Llamado saliente",
    waitTimeText: "Tiempo de espera del cliente"
  },
  dialOut: {
    label: "etiqueta",
    placeHolder: "Utilizar el teclado",
    phoneNumber: "Numero de telefono"
  },
  misc: {
    andOthers: "y otros",
    channelNameX: "Nombre de canalX",
    queueNameX: "Nombre de la cola: {{value}}",
    unknownQueue: "Cola desconocida",
    unknownChannel: "Canal desconocido",
    unknownAgent: "Agente desconocido",
    unknownCustomer: "Cliente desconocido",
    unknownSupervisor: "Supervisor desconocido",
    unknownParticipant: "Participante desconocido",
    unknownPhone: "Numero desconocido",
    initMonitoringCall: "Iniciando llamada de monitorización..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Fallo al iniciar la llamada",
      _DropFailed: "Fallo al cortar la llamada",
      _HoldFailed: "Fallo al retener la llamada",
      _ResumeFailed: "Fallo al reanudar la llamada",
      _TransferFailed: "Fallo al transferir la llamada",
      _ConsultFailed: "Error al iniciar la llamada de consulta",
      _ChangeStateFailed: "Error al cambiar el estado del supervisor",
      _StartFailed: "No se pudo iniciar la llamada"
    },
    details: {
      _ConfigurationError: "Error de configuración Configuración de canal no válida",
      _AgentNotAvailable: "El agente no está disponible en este momento",
      _CapacityReached: "Capacidad máxima alcanzada",
      _AgentNumberNotAvailable: "Número de agente no disponible Su número de teléfono no está configurado",
      _DestinationAgentNumberNotAvailable: "Número de agente de destino no disponible",
      _DestinationNumberNotAvailable: "Número de destino no disponible Número de teléfono de destino no disponible",
      _GenericUnspecified: "Error inesperado",
      _WhisperDisabled: "No se puede susurrar en conferencia",
      _NumberRestricted: "Número de teléfono restringido"
    }
  },
  notifications: {
    newConversation: {
      title: "Llamada entrante",
      description: {
        fromXCustomerPhoneOnXChannel: "De {{phone}} en {{channel}}.",
        acceptToAvoidRona: "Acepta esta tarea ahora para evitar ser movido a la pausa de RONA."
      },
      btnTexts: {
        accept: "Aceptar",
        decline: "Rechazar",
        goToTask: "Ir a la tarea",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Error al conectar usuario",
        configFailed: "No se ha podido obtener la configuración de voz",
        phoneUnregistered: "Se ha perdido el registro del número de teléfono",
        phoneReregistered: "Se ha vuelto a registrar el número de teléfono",
        serverDisconnected: "Se ha perdido la conexión con el servidor de voz",
        serverReconnected: "Se ha restablecido la conexión con el servidor de voz"
      },
      description: {
        reconnectSuggestion: "Estamos intentando restablecer la conexión, pero puede intentar actualizar la página haciendo clic en el siguiente botón"
      },
      refreshBtnText: "Actualizar página"
    }
  }
}, Pt = {
  $schema: Ft,
  translation: Mt
}, Bt = "./schema.json", Ut = {
  callControl: "Contrôle des appels",
  header: {
    collapseTitle: "Réduire l'appel",
    expandTitle: "Développer l'appel"
  },
  callType: {
    _Call: "Appeler",
    _Conference: "Conférence téléphonique",
    _Consultation: "Appel de consultation",
    _Transfer: " Transfert d'appel",
    _Outbound: "Appel sortant"
  },
  actions: {
    btnTooltips: {
      _Mute: "Appel muet",
      _Unmute: "Réactiver l'appel",
      _Hold: "Mettre l'appel en attente",
      _Unhold: "Libérer la attente",
      _AddToCall: "Ajouter à l'appel",
      _OpenDialpad: "Ouvrir le clavier",
      closeDialpad: "Fermer le clavier",
      _OpenDirectory: "Ouvrir le répertoire",
      closeDirectory: "Fermer le répertoire",
      _Transfer: "Transférer l'appel",
      drop: "Abandonner l'appel",
      accept: "Répondre à l'appel"
    },
    btnTitles: {
      _Hold: "Maintenir",
      _Mute: "Muet",
      _AddToCall: "Ajouter à l'appel",
      _OpenDialpad: "Pavé numérique",
      _OpenDirectory: "Annuaire",
      _Transfer: "Transfert",
      consult: "Consulter"
    },
    supervisorActionBtnTexts: {
      monitor: "Surveiller",
      whisper: "chuchoter",
      bargeIn: "faire irruption"
    }
  },
  call: {
    inboundCall: "Appel entrant",
    activeCall: "Appel actif",
    callOnHold: "Appel en attente",
    onHold: "En attente",
    recording: "Enristrement d'appel",
    recordingToggle: "Changement d'enregistrement",
    ended: "Appel termine",
    calling: "Appel"
  },
  preview: {
    incomingX: "Entrant X",
    initiating: "Lancement d'un appel sortant",
    waitTimeText: "Temps d'attente du client"
  },
  dialOut: {
    label: "etiquette",
    placeHolder: "Utiliser le clavier pour la saisie",
    phoneNumber: "Numéro de téléphone"
  },
  misc: {
    andOthers: "et autres",
    channelNameX: "nom de la chaine",
    queueNameX: "Nom de la file d'attente : {{value}}",
    unknownQueue: "File d'attente inconnue",
    unknownChannel: " chiane inconnue",
    unknownAgent: "Agent inconnu",
    unknownCustomer: "Client inconnu",
    unknownSupervisor: "Superviseur inconnu",
    unknownParticipant: "Participant inconnu",
    unknownPhone: "Numero inconnu",
    initMonitoringCall: "Lancement d'un appel de surveillance..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Échec de l'initiation de l'appel",
      _DropFailed: "Échec de l'abandon de l'appel",
      _HoldFailed: "Échec de la mise en attente de l'appel",
      _ResumeFailed: "Échec de la reprise de l'appel",
      _TransferFailed: "Échec du transfert de l'appel",
      _ConsultFailed: "Échec de l'initiation de l'appel de consultation",
      _ChangeStateFailed: "Échec du changement d'état du superviseur",
      _StartFailed: "Échec du démarrage de l'appel"
    },
    details: {
      _ConfigurationError: "Configuration de canal invalide",
      _AgentNotAvailable: "L'agent n'est pas disponible pour le moment",
      _CapacityReached: "Capacité maximale atteinte",
      _AgentNumberNotAvailable: "Votre numéro de téléphone n'est pas configuré",
      _DestinationAgentNumberNotAvailable: "Destination agent's phone number is not available",
      _DestinationNumberNotAvailable: "Destination phone number is not available",
      _GenericUnspecified: "Erreur inattendue",
      _WhisperDisabled: "Impossible de chuchoter en conférence",
      _NumberRestricted: "Numéro de téléphone restreint"
    }
  },
  notifications: {
    newConversation: {
      title: "Appel entrant",
      description: {
        fromXCustomerPhoneOnXChannel: "De {{phone}} sur {{channel}}.",
        acceptToAvoidRona: "Acceptez cette tâche maintenant pour éviter d'être déplacé en pause RONA."
      },
      btnTexts: {
        accept: "Accepter",
        decline: "Refuser",
        goToTask: "Aller à la tâche",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Échec de la connexion de l'utilisateur",
        configFailed: "Échec de l'obtention de la configuration vocale",
        phoneUnregistered: "L'enregistrement du numéro de téléphone a été perdu",
        phoneReregistered: "Le numéro de téléphone a été réenregistré",
        serverDisconnected: "La connexion au serveur vocal a été perdue",
        serverReconnected: "La connexion au serveur vocal est rétablie"
      },
      description: {
        reconnectSuggestion: "Nous essayons de nous reconnecter, mais vous pouvez essayer d'actualiser la page en cliquant sur le bouton ci-dessous."
      },
      refreshBtnText: "Actualiser la page"
    }
  }
}, Xt = {
  $schema: Bt,
  translation: Ut
}, Wt = "./schema.json", Et = {
  callControl: "Hívás Vezérlő",
  header: {
    collapseTitle: "Hívás összecsukása",
    expandTitle: "Hívás kinyitása"
  },
  callType: {
    _Call: "Hívás",
    _Conference: "Konferencia Hívás",
    _Consultation: "Konzultációs Hívás",
    _Transfer: "Átirányított Hívás",
    _Outbound: "Kimenő Hívás"
  },
  actions: {
    btnTooltips: {
      _Mute: "Hívás némítása",
      _Unmute: "Némítás feloldása",
      _Hold: "Hívás várakoztatása",
      _Unhold: "Hívás visszavétele",
      _AddToCall: "Hozzáadás a híváshoz",
      _OpenDialpad: "Gombok megjelenítése",
      closeDialpad: "Gombok elrejtése",
      _OpenDirectory: "Címlisták megjelenítése",
      closeDirectory: "Címlisták elrejtése",
      _Transfer: "Hívás átirányítása",
      drop: "Letesz",
      accept: "Válaszol"
    },
    btnTitles: {
      _Hold: "Várakoztat",
      _Mute: "Némít",
      _AddToCall: "Hozzáad",
      _OpenDialpad: "Gombok",
      _OpenDirectory: "Címlisták",
      _Transfer: "Átirányít",
      consult: "Konzultál"
    },
    supervisorActionBtnTexts: {
      monitor: "Megfigyel",
      whisper: "Suttog",
      bargeIn: "Csatlakozik"
    }
  },
  call: {
    inboundCall: "Bejövő Hívás",
    activeCall: "Aktív Hívás",
    callOnHold: "Hívás várakoztatva",
    onHold: "Várakoztatva",
    recording: "Hívás rögzítése",
    recordingToggle: "Rögzítés vezérlő",
    ended: "A hívás véget ért.",
    calling: "Hívás..."
  },
  preview: {
    incomingX: "Bejövő {{value}}",
    initiating: "Kimenő hívás indítása...",
    waitTimeText: "Ügyfél várakozási ideje"
  },
  dialOut: {
    label: "Kitárcsázás",
    placeHolder: "Használja a billentyűzetet a bevitelhez",
    phoneNumber: "Telefonszám"
  },
  misc: {
    andOthers: "& mások",
    channelNameX: "Csatorna neve: {{value}}",
    queueNameX: "Várólista neve: {{value}}",
    unknownQueue: "Ismeretlen Várólista",
    unknownChannel: "Ismeretlen Csatorna",
    unknownAgent: "Ismeretlen Ügynök",
    unknownCustomer: "Ismeretlen Ügyfél",
    unknownSupervisor: "Ismeretlen Felügyelő",
    unknownParticipant: "Ismeretlen Résztvevő",
    unknownPhone: "Ismeretlen Telefonszám",
    initMonitoringCall: "Megfigyelő hívás indítása..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Hívás indítás sikertelen",
      _DropFailed: "Hívás letétele sikertelen",
      _HoldFailed: "Hívás várakoztatása sikertelen",
      _ResumeFailed: "Hívás visszavétele sikertelen",
      _TransferFailed: "Hívás átirányítása sikertelen",
      _ConsultFailed: "Konzultációs hívás indítása sikertelen",
      _ChangeStateFailed: "Felügyelő státusz megváltoztatása sikertelen",
      _StartFailed: "Nem sikerült hívást kezdeni"
    },
    details: {
      _ConfigurationError: "Érvénytelen csatorna konfiguráció",
      _AgentNotAvailable: "Az ügynök jelenleg nem elérhető",
      _CapacityReached: "Maximális kapacitás elérve",
      _AgentNumberNotAvailable: "A telefonszáma nem konfigurált",
      _DestinationAgentNumberNotAvailable: "A célzott ügynök telefonszáma nem elérhető",
      _DestinationNumberNotAvailable: "A célzott telefonszám nem elérhető",
      _GenericUnspecified: "Váratlan hiba",
      _WhisperDisabled: "Nem sikerült besúgni a konferenciába",
      _NumberRestricted: "Korlátozott telefonszám"
    }
  },
  notifications: {
    newConversation: {
      title: "Bejövő hívás",
      description: {
        fromXCustomerPhoneOnXChannel: "{{phone}} ügyféltől {{channel}} csatornán.",
        acceptToAvoidRona: "Fogadd el ezt a feladatot most, hogy elkerüld a RONA szünetre való kerülést."
      },
      btnTexts: {
        accept: "Elfogadás",
        decline: "Visszautasít",
        goToTask: "Váltás a Feladatra",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Nem sikerült csatlakoztatni a felhasználót",
        configFailed: "Hívás konfiguráció nem található",
        phoneUnregistered: "A telefonszám regisztrációja elveszett",
        phoneReregistered: "A telefonszám újra regisztrálva lett",
        serverDisconnected: "A kapcsolat megszakadt a híváskezelő szerverrel",
        serverReconnected: "A kapcsolat helyreállt a híváskezelő szerverrel"
      },
      description: {
        reconnectSuggestion: "Próbálunk újra csatlakozni, de az alábbi gomb megnyomásával frissítheted az oldalt"
      },
      refreshBtnText: "Oldal frissítése"
    }
  }
}, Lt = {
  $schema: Wt,
  translation: Et
}, Gt = "./schema.json", qt = {
  callControl: "controllo chiamata",
  header: {
    collapseTitle: "comprimi chiamata",
    expandTitle: "espandi chiamata"
  },
  callType: {
    _Call: "Chiama",
    _Conference: "Conferenza telefonica",
    _Consultation: "Chimata di consultazione",
    _Transfer: "Trasferimento di chiamata",
    _Outbound: "Chimata in uscita"
  },
  actions: {
    btnTooltips: {
      _Mute: "chimata disattivata",
      _Unmute: "Riattiva chiamata",
      _Hold: "Attesa",
      _Unhold: "Rilascia",
      _AddToCall: "Aggiungi la chiamata",
      _OpenDialpad: "Apri Tastiera",
      closeDialpad: "Chuidi Tastiera",
      _OpenDirectory: "Apri Directory",
      closeDirectory: "Chiudi Directory",
      _Transfer: "Trasferisci",
      drop: "Interrompi",
      accept: "Rispondi"
    },
    btnTitles: {
      _Hold: "Tieni Premuto",
      _Mute: "Muto",
      _AddToCall: "Aggiungi la chiamata",
      _OpenDialpad: "Apri Tastierino",
      _OpenDirectory: "Apri Directory",
      _Transfer: "Trasferisci",
      consult: "consultare"
    },
    supervisorActionBtnTexts: {
      monitor: "Monitor",
      whisper: "Sussurro",
      bargeIn: "Entra"
    }
  },
  call: {
    inboundCall: "Chiamata in Entrata",
    activeCall: "Chiamata Attiva",
    callOnHold: "Chimata in attesa",
    onHold: "in attesa",
    recording: "registrazione",
    recordingToggle: "attiva/disattiva registrazione",
    ended: "Terminata",
    calling: "Chiama"
  },
  preview: {
    incomingX: "In arrivoX",
    initiating: "Avvio della chiamta in uscita",
    waitTimeText: "Tempo di attesa del cliente"
  },
  dialOut: {
    label: "etichetta chiama in uscita",
    placeHolder: "Utilizza la tastiera per l'immissione",
    phoneNumber: "Numero di telefono"
  },
  misc: {
    andOthers: "Altri",
    channelNameX: "Nome canale X",
    queueNameX: "Nome della coda: {{value}}",
    unknownQueue: "Coda sconosciuta",
    unknownChannel: "Canale sconosciuto",
    unknownAgent: "Agente sconosciuto",
    unknownCustomer: "Cliente sconosciuto",
    unknownSupervisor: "Supervisore sconosciuto",
    unknownParticipant: "Patrecipante sconosciuto",
    unknownPhone: "Nummero sconosciuto",
    initMonitoringCall: "Avvio della chiamta di monitoraggio"
  },
  failure: {
    title: {
      _MakeCallFailed: "Fallito l'avvio della chiamata",
      _DropFailed: "Chiamata non riuscita",
      _HoldFailed: "Chiamata in attesa non riuscita",
      _ResumeFailed: "Ripresa chiamata fallita",
      _TransferFailed: "Trasferimento di chiamata non riuscito",
      _ConsultFailed: "Fallito l'avvio della chiamata di consultazione",
      _ChangeStateFailed: "Impossibile cambiare lo stato del supervisore",
      _StartFailed: "Impossibile avviare la chiamata"
    },
    details: {
      _ConfigurationError: "Configurazione del canale non valida",
      _AgentNotAvailable: "L'agente non è disponibile al momento",
      _CapacityReached: "Capacità massima raggiunta",
      _AgentNumberNotAvailable: "Il numero di telefono non è configurato",
      _DestinationAgentNumberNotAvailable: "Il numero di telefono dell'agente di destinazione non è disponibile",
      _DestinationNumberNotAvailable: "Il numero di telefono della destinazione non è disponibile",
      _GenericUnspecified: "Errore imprevisto",
      _WhisperDisabled: "Impossibile sussurrare in conferenza",
      _NumberRestricted: "Numero di telefono limitato"
    }
  },
  notifications: {
    newConversation: {
      title: "Chiamata in arrivo",
      description: {
        fromXCustomerPhoneOnXChannel: "Da {{phone}} su {{channel}}.",
        acceptToAvoidRona: "Accetta questo compito ora per evitare di essere spostato in pausa RONA."
      },
      btnTexts: {
        accept: "Accetta",
        decline: "Rifiuta",
        goToTask: "Vai al compito",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Impossibile connettere l'utente",
        configFailed: "Impossibile ottenere la configurazione vocale",
        phoneUnregistered: "La registrazione del numero di telefono è stata persa",
        phoneReregistered: "Il numero di telefono è stato registrato nuovamente",
        serverDisconnected: "Connection to voice server has been lost",
        serverReconnected: "Connection to voice server is restored"
      },
      description: {
        reconnectSuggestion: "Stiamo cercando di riconnetterci, ma potete provare ad aggiornare la pagina facendo clic sul pulsante qui sotto"
      },
      refreshBtnText: "Aggiornare"
    }
  }
}, Vt = {
  $schema: Gt,
  translation: qt
}, Kt = "./schema.json", Qt = {
  callControl: "oproepbeheer",
  header: {
    collapseTitle: "oproep samenvouwen",
    expandTitle: "oproep uitbreiden"
  },
  callType: {
    _Call: "bellen",
    _Conference: "conferentie gesprek",
    _Consultation: "consultatie gesprek",
    _Transfer: "gesprek doorverbinden",
    _Outbound: "uitgaand gesprek"
  },
  actions: {
    btnTooltips: {
      _Mute: "gesprek dempen",
      _Unmute: "gesprek opheffen",
      _Hold: "gesprek in de wacht zetten",
      _Unhold: "uit de wacht halen",
      _AddToCall: "toevoegen aan oproep",
      _OpenDialpad: "open toetsenblok",
      closeDialpad: "kiestoetsen sluiten",
      _OpenDirectory: "open directory map",
      closeDirectory: "Map sluiten",
      _Transfer: "gesprek doorverbinden",
      drop: "gesprek afbreken",
      accept: "oproep beantwoorden"
    },
    btnTitles: {
      _Hold: "hold",
      _Mute: "dempen",
      _AddToCall: "toevoegen aan oproep",
      _OpenDialpad: "open kiestoetsenbord",
      _OpenDirectory: "open directory map",
      _Transfer: "doorverbinden",
      consult: "raadpleeg"
    },
    supervisorActionBtnTexts: {
      monitor: "monitor",
      whisper: "fluisteren",
      bargeIn: "binnenkomen"
    }
  },
  call: {
    inboundCall: "inkomend gesprek",
    activeCall: "actieve oproep",
    callOnHold: "gesprek in de wacht",
    onHold: "in de wacht",
    recording: "opname",
    recordingToggle: "opname wisselen",
    ended: "gesprek beeindigd",
    calling: "bellen"
  },
  preview: {
    incomingX: "inkomendeX",
    initiating: "initieren",
    waitTimeText: "Wachttijd klant"
  },
  dialOut: {
    label: "bellen",
    placeHolder: "gebruik toetsenbord voor invoer",
    phoneNumber: "telefoonnummer"
  },
  misc: {
    andOthers: "Anderen",
    channelNameX: "kanaalnaamX",
    queueNameX: "Wachtrijnaam: {{value}}",
    unknownQueue: "Onbekende wachtrij",
    unknownChannel: "onbekend kanaal",
    unknownAgent: "onbekende agent",
    unknownCustomer: "onbekende klant",
    unknownSupervisor: "onbekende supervisor",
    unknownParticipant: "onbekende deelnemer",
    unknownPhone: "onbekend nummer",
    initMonitoringCall: "initieren van monitoring oproep"
  },
  failure: {
    title: {
      _MakeCallFailed: "Starten van oproep mislukt",
      _DropFailed: "gesprek doorverbinden mislukt",
      _HoldFailed: "gesprek in de wacht mislukt",
      _ResumeFailed: "oproep hervatten mislukt",
      _TransferFailed: "kan het gesprek niet doorverbinden",
      _ConsultFailed: "kan de consultatiegesprek niet starten",
      _ChangeStateFailed: "kan de supervisorstatus niet wijzigen",
      _StartFailed: "Kon het gesprek niet starten"
    },
    details: {
      _ConfigurationError: "ongeldige kanaal configuratie",
      _AgentNotAvailable: "agent niet beschikbaar",
      _CapacityReached: "maximale capacitiet bereikt",
      _AgentNumberNotAvailable: "agent nummer niet beschikbaar",
      _DestinationAgentNumberNotAvailable: "telefoonnummer van bestemmings agent niet beschikbaar",
      _DestinationNumberNotAvailable: "bestemmings nummer niet beschikbaar",
      _GenericUnspecified: "onverwachte fout",
      _WhisperDisabled: "FLuisteren uitgezet",
      _NumberRestricted: "beperkt telefoon nummer"
    }
  },
  notifications: {
    newConversation: {
      title: "Inkomende oproep",
      description: {
        fromXCustomerPhoneOnXChannel: "Van {{phone}} op {{channel}}.",
        acceptToAvoidRona: "Accepteer deze taak nu om te voorkomen dat je naar een RONA-pauze wordt verplaatst."
      },
      btnTexts: {
        accept: "Accepteren",
        decline: "Weigeren",
        goToTask: "Ga naar taak",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Verbinding met gebruiker mislukt",
        configFailed: "Gespreksconfiguratie niet verkregen",
        phoneUnregistered: "De registratie van het telefoonnummer is verloren gegaan",
        phoneReregistered: "Telefoonnummer is opnieuw geregistreerd",
        serverDisconnected: "Verbinding met stemserver is verloren gegaan",
        serverReconnected: "Verbinding met stemserver is hersteld"
      },
      description: {
        reconnectSuggestion: "We proberen opnieuw verbinding te maken, maar u kunt proberen de pagina te verversen door op de onderstaande knop te klikken"
      },
      refreshBtnText: "Pagina verversen"
    }
  }
}, Zt = {
  $schema: Kt,
  translation: Qt
}, Yt = "./schema.json", Jt = {
  callControl: "Control Apel",
  header: {
    collapseTitle: "Colapsează control",
    expandTitle: "Extinde control"
  },
  callType: {
    _Call: "Apel",
    _Conference: "Apel conferință",
    _Consultation: "Apel consultativ",
    _Transfer: "Apel transfer",
    _Outbound: "Apel extern"
  },
  actions: {
    btnTooltips: {
      _Mute: "Mut",
      _Unmute: "Vorbeste",
      _Hold: "Pune În așteptare",
      _Unhold: "Reluare",
      _AddToCall: "Adaugă in apel",
      _OpenDialpad: "Deschide taste de apelare",
      closeDialpad: "Închide taste de apelare",
      _OpenDirectory: "Deschide director",
      closeDirectory: "Închide director",
      _Transfer: "Transferă apel",
      drop: "Închide",
      accept: "Acceptă"
    },
    btnTitles: {
      _Hold: "Așteptare",
      _Mute: "Mut",
      _AddToCall: "Conferință",
      _OpenDialpad: "Tastatură",
      _OpenDirectory: "Catalog",
      _Transfer: "Transfer",
      consult: "Consultare"
    },
    supervisorActionBtnTexts: {
      monitor: "Ascultă",
      whisper: "Șoptește",
      bargeIn: "Vorbește"
    }
  },
  call: {
    inboundCall: "Apel primit",
    activeCall: "Apel activ",
    callOnHold: "Apel in așteptare",
    onHold: "În așteptare",
    recording: "Înregistrare apel",
    recordingToggle: "Comutator de înregistrare",
    ended: "Apel încheiat",
    calling: "Apelare..."
  },
  preview: {
    incomingX: "Intră {{value}}",
    initiating: "Se inițiaza apel de ieșire..",
    waitTimeText: "Timp de așteptare client"
  },
  dialOut: {
    label: "Apelare extern",
    placeHolder: "Folosește tastatura pentru introducere",
    phoneNumber: "Număr de telefon"
  },
  misc: {
    andOthers: "& altele",
    channelNameX: "Nume canal: {{value}}",
    queueNameX: "Nume coadă: {{value}}",
    unknownQueue: "Coadă necunoscută",
    unknownChannel: "Canal necunoscut",
    unknownAgent: "Agent necunoscut",
    unknownCustomer: "Client necunoscut",
    unknownSupervisor: "Supervisor necunoscut",
    unknownParticipant: "Participant necunoscut",
    unknownPhone: "Număr necunoscut",
    initMonitoringCall: "Se initiază ascultare apel"
  },
  failure: {
    title: {
      _MakeCallFailed: "Inițiere apel eșuată",
      _DropFailed: "Închidere apel eșuată",
      _HoldFailed: "Punere apel in așteptare eșuată",
      _ResumeFailed: "Reluare apel eșuată",
      _TransferFailed: "Transferare apel eșuat",
      _ConsultFailed: "Inițierea apelului consultativ a eșuat",
      _ChangeStateFailed: "Schimbarea statului supervisor a eșuat",
      _StartFailed: "Nu s-a putut iniția apelul"
    },
    details: {
      _ConfigurationError: "Canal configurat invalid",
      _AgentNotAvailable: "Agentul nu este disponibil momentan",
      _CapacityReached: "Capacitate maximă atinsă",
      _AgentNumberNotAvailable: "Numărul tău de telefon nu este configurat",
      _DestinationAgentNumberNotAvailable: "Numărul agentului țintă nu este disponibil",
      _DestinationNumberNotAvailable: "Număr de telefon țintă indisponibil",
      _GenericUnspecified: "Eroare neprevazută",
      _WhisperDisabled: "Functie indisponibilă în conferință",
      _NumberRestricted: "Numărul de telefon este restricționat"
    }
  },
  notifications: {
    newConversation: {
      title: "Apel primit",
      description: {
        fromXCustomerPhoneOnXChannel: "De la {{phone}} pe {{channel}}.",
        acceptToAvoidRona: "Acceptați această sarcină acum pentru a evita trecerea în pauza RONA."
      },
      btnTexts: {
        accept: "Acceptă",
        decline: "Respinge",
        goToTask: "Mergi la sarcină",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Conectare utilizator eșuată",
        configFailed: "Obținerea configurării voce a eșuat",
        phoneUnregistered: "Înregistrarea numărului de telefon a fost pierdută",
        phoneReregistered: "Numărul de telefon a fost reînregistrat",
        serverDisconnected: "Conexiunea cu serverul de voce a fost pierdută",
        serverReconnected: "Conexiunea cu serverul de voce este restabilită"
      },
      description: {
        reconnectSuggestion: "Încercăm să ne reconectăm, dar puteți încerca să reîmprospătați pagina făcând clic pe butonul de mai jos"
      },
      refreshBtnText: "reîmprospătați pagina"
    }
  }
}, ei = {
  $schema: Yt,
  translation: Jt
}, ni = {
  callControl: "Çağrı Kontrolü",
  header: {
    collapseTitle: "Çağrıyı Küçült",
    expandTitle: "Çağrıyı Büyüt"
  },
  callType: {
    _Call: "Çağrı",
    _Conference: "Konferans Çağrısı",
    _Consultation: "Danışma Çağrısı",
    _Transfer: "Çağrı Aktarma",
    _Outbound: "Gelen Çağrı"
  },
  actions: {
    btnTooltips: {
      _Mute: "Çağrıyı sessize al",
      _Unmute: "Çağrının sesini aç",
      _Hold: "Çağrıyı beklemeye al",
      _Unhold: "Çağrıyı beklemeden çıkar",
      _AddToCall: "Çağrıya ekle",
      _OpenDialpad: "Tuş takımını aç",
      closeDialpad: "Tuş takımını kapat",
      _OpenDirectory: "Rehberi aç",
      closeDirectory: "Rehberi kapat",
      _Transfer: "Çağrıyı aktar",
      drop: "Çağrıyı sonlandır",
      accept: "Çağrıyı yanıtla"
    },
    btnTitles: {
      _Hold: "Beklet",
      _Mute: "Sessize Al",
      _AddToCall: "Çağrıya Ekle",
      _OpenDialpad: "Tuş Takımı",
      _OpenDirectory: "Rehber",
      _Transfer: "Aktar",
      consult: "Danışma"
    },
    supervisorActionBtnTexts: {
      monitor: "Gözetle",
      whisper: "Fısılda",
      bargeIn: "Sözünü kes"
    }
  },
  call: {
    inboundCall: "Gelen Çağrı",
    activeCall: "Aktif Çağrı",
    callOnHold: "Çağrı beklemede",
    onHold: "Beklemede",
    recording: "Çağrı kaydı",
    recordingToggle: "Kayıt Açma/Kapama",
    ended: "Çağrı sonlandı.",
    calling: "Aranıyor..."
  },
  preview: {
    incomingX: "Gelen {{value}}",
    initiating: "Gelen çağrı başlatılıyor...",
    waitTimeText: "Müşteri bekleme süresi"
  },
  dialOut: {
    label: "Dış Arama",
    placeHolder: "Girdi için klavyeyi kullanın",
    phoneNumber: "Telefon numarası"
  },
  misc: {
    andOthers: "& diğerleri",
    channelNameX: "Kanal adı: {{value}}",
    queueNameX: "Kuyruk adı: {{value}}",
    unknownQueue: "Bilinmeyen Kuyruk",
    unknownChannel: "Bilinmeyen Kanal",
    unknownAgent: "Bilinmeyen Temsilci",
    unknownCustomer: "Bilinmeyen Müşteri",
    unknownSupervisor: "Bilinmeyen Süpervizör",
    unknownParticipant: "Bilinmeyen Katılımcı",
    unknownPhone: "Bilinmeyen Numara",
    initMonitoringCall: "Gözetleme çağrısı başlatılıyor..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Çağrı başlatılamadı",
      _DropFailed: "Çağrı sonlandıramadı",
      _HoldFailed: "Çağrı bekletilemedi",
      _ResumeFailed: "Çağrı devam ettirilemedi",
      _TransferFailed: "Çağrı aktarılamadı",
      _ConsultFailed: "Danışma çağrısı başlatılamadı",
      _ChangeStateFailed: "Süpervizör durumu değiştirilemedi",
      _StartFailed: "Çağrı başlatılamadı"
    },
    details: {
      _ConfigurationError: "Geçersiz kanal yapılandırması",
      _AgentNotAvailable: "Temsilci şu anda müsait değil",
      _CapacityReached: "Maksimum kapasiteye ulaşıldı",
      _AgentNumberNotAvailable: "Telefon numaranız yapılandırılmamış",
      _DestinationAgentNumberNotAvailable: "Hedef temsilcinin telefon numarası mevcut değil",
      _DestinationNumberNotAvailable: "Hedef telefon numarası mevcut değil",
      _GenericUnspecified: "Beklenmeyen hata",
      _WhisperDisabled: "Konferansta fısıldama yapılamıyor",
      _NumberRestricted: "Sınırlı telefon numarası"
    }
  },
  notifications: {
    newConversation: {
      title: "Gelen çağrı",
      description: {
        fromXCustomerPhoneOnXChannel: "{{phone}} numaralı telefondan {{channel}} üzerinde.",
        acceptToAvoidRona: "RONA molasına geçmemeniz için bu görevi şimdi kabul edin."
      },
      btnTexts: {
        accept: "Kabul Et",
        decline: "Reddet",
        goToTask: "Göreve Git",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Kullanıcı bağlantısı kurulamadı",
        configFailed: "Ses yapılandırması alınamadı",
        phoneUnregistered: "Telefon numarası kaydı kayboldu",
        phoneReregistered: "Telefon numarası yeniden kaydedildi",
        serverDisconnected: "Ses sunucusuna bağlantı kayboldu",
        serverReconnected: "Ses sunucusuna bağlantı geri sağlandı"
      },
      description: {
        reconnectSuggestion: "Yeniden bağlanmaya çalışıyoruz, ancak aşağıdaki düğmeyi tıklayarak sayfayı yenilemeyi deneyebilirsiniz"
      },
      refreshBtnText: "Sayfayı Yenile"
    }
  }
}, ti = {
  translation: ni
}, ii = {
  callControl: "Kontrola poziva",
  header: {
    collapseTitle: "Sažmi poziv",
    expandTitle: "Proširi poziv"
  },
  callType: {
    _Call: "Poziv",
    _Conference: "Konferencijski poziv",
    _Consultation: "Konzultativni poziv",
    _Transfer: "Prosljeđivanje poziva",
    _Outbound: "Izlazni poziv"
  },
  actions: {
    btnTooltips: {
      _Mute: "Isključi zvuk poziva",
      _Unmute: "Uključi zvuk poziva",
      _Hold: "Stavi poziv na čekanje",
      _Unhold: "Ukloni čekanje poziva",
      _AddToCall: "Dodaj u poziv",
      _OpenDialpad: "Otvori tipkovnicu",
      closeDialpad: "Zatvori tipkovnicu",
      _OpenDirectory: "Otvori imenik",
      closeDirectory: "Zatvori imenik",
      _Transfer: "Proslijedi poziv",
      drop: "Prekini poziv",
      accept: "Prihvati poziv"
    },
    btnTitles: {
      _Hold: "Čekanje",
      _Mute: "Isključi zvuk",
      _AddToCall: "Dodaj u poziv",
      _OpenDialpad: "Tipkovnica",
      _OpenDirectory: "Imenik",
      _Transfer: "Proslijedi",
      consult: "Konzultiraj"
    },
    supervisorActionBtnTexts: {
      monitor: "Nadziranje",
      whisper: "Šaptanje",
      bargeIn: "Prekid"
    }
  },
  call: {
    inboundCall: "Dolazni poziv",
    activeCall: "Aktivni poziv",
    callOnHold: "Poziv na čekanju",
    onHold: "Na čekanju",
    recording: "Snimanje poziva",
    recordingToggle: "Prekidač za snimanje",
    ended: "Poziv završen.",
    calling: "Pozivanje..."
  },
  preview: {
    incomingX: "Dolazni {{value}}",
    initiating: "Pokretanje izlaznog poziva...",
    waitTimeText: "Vrijeme čekanja korisnika"
  },
  dialOut: {
    label: "Pozovi",
    placeHolder: "Koristite tipkovnicu za unos",
    phoneNumber: "Broj telefona"
  },
  misc: {
    andOthers: "& drugi",
    channelNameX: "Naziv kanala: {{value}}",
    queueNameX: "Naziv reda: {{value}}",
    unknownQueue: "Nepoznati red",
    unknownChannel: "Nepoznati kanal",
    unknownAgent: "Nepoznati agent",
    unknownCustomer: "Nepoznati korisnik",
    unknownSupervisor: "Nepoznati nadzornik",
    unknownParticipant: "Nepoznati sudionik",
    unknownPhone: "Nepoznati broj",
    initMonitoringCall: "Pokretanje nadzornog poziva..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Neuspješno pokretanje poziva",
      _DropFailed: "Neuspješno prekidanje poziva",
      _HoldFailed: "Neuspješno stavljanje poziva na čekanje",
      _ResumeFailed: "Neuspješno vraćanje poziva s čekanja",
      _TransferFailed: "Neuspješno prosljeđivanje poziva",
      _ConsultFailed: "Neuspješno pokretanje konzultativnog poziva",
      _ChangeStateFailed: "Neuspješna promjena stanja nadzornika",
      _StartFailed: "Neuspješno pokretanje poziva"
    },
    details: {
      _ConfigurationError: "Neispravna konfiguracija kanala",
      _AgentNotAvailable: "Agent trenutno nije dostupan",
      _CapacityReached: "Dosegnut maksimalni kapacitet",
      _AgentNumberNotAvailable: "Vaš broj telefona nije konfiguriran",
      _DestinationAgentNumberNotAvailable: "Broj telefona odredišnog agenta nije dostupan",
      _DestinationNumberNotAvailable: "Odredišni broj telefona nije dostupan",
      _GenericUnspecified: "Neočekivana greška",
      _WhisperDisabled: "Nemoguće šaptati tijekom konferencije",
      _NumberRestricted: "Ograničeni broj telefona"
    }
  },
  notifications: {
    newConversation: {
      title: "Dolazni poziv",
      description: {
        fromXCustomerPhoneOnXChannel: "Od {{phone}} na {{channel}}.",
        acceptToAvoidRona: "Prihvatite ovaj zadatak sada kako biste izbjegli prelazak na RONA pauzu."
      },
      btnTexts: {
        accept: "Prihvati",
        decline: "Odbij",
        goToTask: "Idi na zadatak",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Neuspješno povezivanje korisnika",
        configFailed: "Neuspješno preuzimanje konfiguracije za glas",
        phoneUnregistered: "Registracija broja telefona je izgubljena",
        phoneReregistered: "Broj telefona je ponovno registriran",
        serverDisconnected: "Veza s glasovnim poslužiteljem je izgubljena",
        serverReconnected: "Veza s glasovnim poslužiteljem je obnovljena"
      },
      description: {
        reconnectSuggestion: "Pokušavamo ponovno uspostaviti vezu, ali možete pokušati osvježiti stranicu klikom na gumb ispod"
      },
      refreshBtnText: "Osvježi stranicu"
    }
  }
}, ai = {
  translation: ii
}, oi = {
  callControl: "Kontrola poziva",
  header: {
    collapseTitle: "Sažmi poziv",
    expandTitle: "Proširi poziv"
  },
  callType: {
    _Call: "Poziv",
    _Conference: "Konferencijski poziv",
    _Consultation: "Konsultativni poziv",
    _Transfer: "Prosleđivanje poziva",
    _Outbound: "Izlazni poziv"
  },
  actions: {
    btnTooltips: {
      _Mute: "Isključi zvuk poziva",
      _Unmute: "Uključi zvuk poziva",
      _Hold: "Stavi poziv na čekanje",
      _Unhold: "Skini poziv sa čekanja",
      _AddToCall: "Dodaj u poziv",
      _OpenDialpad: "Otvori tastaturu",
      closeDialpad: "Zatvori tastaturu",
      _OpenDirectory: "Otvori imenik",
      closeDirectory: "Zatvori imenik",
      _Transfer: "Prosledi poziv",
      drop: "Prekini poziv",
      accept: "Prihvati poziv"
    },
    btnTitles: {
      _Hold: "Čekanje",
      _Mute: "Isključi zvuk",
      _AddToCall: "Dodaj u poziv",
      _OpenDialpad: "Tastatura",
      _OpenDirectory: "Imenik",
      _Transfer: "Prosledi",
      consult: "Konsultuj"
    },
    supervisorActionBtnTexts: {
      monitor: "Nadzor",
      whisper: "Šapat",
      bargeIn: "Prekini"
    }
  },
  call: {
    inboundCall: "Dolazni poziv",
    activeCall: "Aktivan poziv",
    callOnHold: "Poziv na čekanju",
    onHold: "Na čekanju",
    recording: "Snimanje poziva",
    recordingToggle: "Prekidač za snimanje",
    ended: "Poziv završen.",
    calling: "Pozivanje..."
  },
  preview: {
    incomingX: "Dolazni {{value}}",
    initiating: "Pokretanje izlaznog poziva...",
    waitTimeText: "Vreme čekanja korisnika"
  },
  dialOut: {
    label: "Pozovi",
    placeHolder: "Koristite tastaturu za unos",
    phoneNumber: "Broj telefona"
  },
  misc: {
    andOthers: "& drugi",
    channelNameX: "Naziv kanala: {{value}}",
    queueNameX: "Naziv reda: {{value}}",
    unknownQueue: "Nepoznat red",
    unknownChannel: "Nepoznat kanal",
    unknownAgent: "Nepoznat agent",
    unknownCustomer: "Nepoznat korisnik",
    unknownSupervisor: "Nepoznat supervizor",
    unknownParticipant: "Nepoznat učesnik",
    unknownPhone: "Nepoznat broj",
    initMonitoringCall: "Pokretanje nadzornog poziva..."
  },
  failure: {
    title: {
      _MakeCallFailed: "Neuspešno pokretanje poziva",
      _DropFailed: "Neuspešno prekidanje poziva",
      _HoldFailed: "Neuspešno stavljanje poziva na čekanje",
      _ResumeFailed: "Neuspešno vraćanje poziva sa čekanja",
      _TransferFailed: "Neuspešno prosleđivanje poziva",
      _ConsultFailed: "Neuspešno pokretanje konsultativnog poziva",
      _ChangeStateFailed: "Neuspešna promena stanja supervizora",
      _StartFailed: "Neuspešno pokretanje poziva"
    },
    details: {
      _ConfigurationError: "Neispravna konfiguracija kanala",
      _AgentNotAvailable: "Agent trenutno nije dostupan",
      _CapacityReached: "Dosegnut maksimalni kapacitet",
      _AgentNumberNotAvailable: "Vaš broj telefona nije konfigurisan",
      _DestinationAgentNumberNotAvailable: "Broj telefona ciljnog agenta nije dostupan",
      _DestinationNumberNotAvailable: "Ciljni broj telefona nije dostupan",
      _GenericUnspecified: "Neočekivana greška",
      _WhisperDisabled: "Nemoguće šaptati tokom konferencije",
      _NumberRestricted: "Ograničen broj telefona"
    }
  },
  notifications: {
    newConversation: {
      title: "Dolazni poziv",
      description: {
        fromXCustomerPhoneOnXChannel: "Od {{phone}} na {{channel}}.",
        acceptToAvoidRona: "Prihvatite ovaj zadatak odmah da biste izbegli prelazak na RONA pauzu."
      },
      btnTexts: {
        accept: "Prihvati",
        decline: "Odbij",
        goToTask: "Idi na zadatak",
        acceptAndGoToTask: "$t(notifications.newConversation.btnTexts.accept) & $t(notifications.newConversation.btnTexts.goToTask)"
      }
    },
    webRtc: {
      message: {
        userConnectFailed: "Neuspešno povezivanje korisnika",
        configFailed: "Neuspešno preuzimanje konfiguracije za glas",
        phoneUnregistered: "Registracija broja telefona je izgubljena",
        phoneReregistered: "Broj telefona je ponovo registrovan",
        serverDisconnected: "Veza sa glasovnim serverom je izgubljena",
        serverReconnected: "Veza sa glasovnim serverom je obnovljena"
      },
      description: {
        reconnectSuggestion: "Pokušavamo ponovo da uspostavimo vezu, ali možete pokušati osvežiti stranicu klikom na dugme ispod"
      },
      refreshBtnText: "Osveži stranicu"
    }
  }
}, ri = {
  translation: oi
}, gn = {
  "en-US": It,
  "hu-HU": Lt,
  "ro-RO": ei,
  "de-DE": Ot,
  "es-ES": Pt,
  "fr-FR": Xt,
  "it-IT": Vt,
  "nl-NL": Zt,
  "tr-TR": ti,
  "hr-HR": ai,
  "sr-RS": ri
};
class li {
  constructor(n, a) {
    C(this, "user");
    C(this, "audioElement");
    C(this, "eventHandler");
    C(this, "autoAnswerEnabled");
    this.audioElement = n, this.eventHandler = a;
  }
  async start(n, a) {
    let i;
    try {
      i = await this.fetchFreePbxConfig(a, n);
    } catch {
      return { isSuccess: !1, error: "GetConfigFailed" };
    }
    if (!i)
      return { isSuccess: !0, hasConfig: !1 };
    this.autoAnswerEnabled = i.autoAnswerEnabled;
    const s = new URL(i.freePBXAddress).hostname.replace("www.", ""), l = Gn.makeURI(`sip:${i.extension}@${s}`), o = Xn();
    this.user = new qn(i.freePBXAddress, {
      userAgentOptions: {
        authorizationPassword: i.password,
        authorizationUsername: i.extension,
        uri: l,
        displayName: "Buzzeasy",
        sessionDescriptionHandlerFactoryOptions: {
          iceGatheringTimeout: 500
        },
        logLevel: "warn",
        contactName: `${i.extension}-${o}`
        // used as session id
      },
      media: {
        remote: {
          audio: this.audioElement
        }
      },
      delegate: this.eventHandler,
      //these 2 are deprecated in userAgentOptions
      reconnectionAttempts: 3,
      reconnectionDelay: 5
    });
    try {
      await this.user.connect();
    } catch {
      return { isSuccess: !1, error: "UserConnectFailed" };
    }
    return await this.user.register(), { isSuccess: !0, hasConfig: !0 };
  }
  async answer() {
    var n;
    try {
      await ((n = this.user) == null ? void 0 : n.answer());
    } catch (a) {
      console.error("Failed to answer call", { error: a });
    }
  }
  async hangup() {
    var n;
    try {
      await ((n = this.user) == null ? void 0 : n.hangup());
    } catch (a) {
      console.error("Failed to hang up call", { error: a });
    }
  }
  createHeaders(n) {
    return {
      Accept: "application/json",
      Authorization: `Bearer ${n}`
    };
  }
  async fetchFreePbxConfig(n, a) {
    const i = this.createHeaders(a), r = await fetch(n + "/freepbx/me/freepbxconfig", { headers: i });
    if (!r.ok)
      throw new Error("Failed to fetch freePBX config");
    if (r.status === 204)
      return null;
    if (r.status === 200)
      return await r.json();
    throw new Error("Failed to fetch freePBX config");
  }
}
const si = "https://cdn.geomant.cloud/buzzeasy/agent-ringtone.mp3", $e = Nn.createContext(void 0), Ua = ({ token: e, apiBaseUrl: n, children: a, notificationApi: i, language: r, options: s }) => {
  const [l, o] = V(), [h, d] = V(!1), [b, m] = V(void 0), [g, u] = V(void 0), O = Re(void 0);
  O.current = g;
  const [N, k] = V(void 0), T = Re(void 0);
  T.current = N;
  const $ = Re(), v = X(
    () => {
      const y = rn.createInstance();
      return y.use(nn).init({
        resources: gn,
        lng: r,
        fallbackLng: "en-US",
        interpolation: {
          escapeValue: !1
        }
      }), y.t;
    },
    [r]
  ), _ = v("notifications.webRtc.refreshBtnText"), w = j(
    (y) => {
      const I = new li(y, {
        onServerConnect() {
          k(!0), T.current === !1 && (i.destroy("cc-server-disconnected"), i.success({
            key: "cc-server-reconnected",
            message: v("notifications.webRtc.message.serverReconnected"),
            role: "status"
          }));
        },
        onServerDisconnect() {
          k(!1), i.error({
            key: "cc-server-disconnected",
            message: v("notifications.webRtc.message.serverDisconnected"),
            description: v("notifications.webRtc.description.reconnectSuggestion"),
            btn: /* @__PURE__ */ t(R, { type: "primary", size: "small", onClick: () => window.location.reload(), children: _ })
          });
        },
        onRegistered() {
          u(!0), O.current === !1 && (i.destroy("cc-phone-unregistered"), i.success({
            key: "cc-phone-registered",
            message: v("notifications.webRtc.message.phoneReregistered"),
            role: "status"
          }));
        },
        onUnregistered() {
          u(!1), i.error({
            key: "cc-phone-unregistered",
            message: v("notifications.webRtc.message.phoneUnregistered"),
            btn: /* @__PURE__ */ t(R, { type: "primary", size: "small", onClick: () => window.location.reload(), children: _ })
          });
        },
        onCallReceived: () => {
          y.play(), d(!0);
        },
        onCallHangup: () => {
          y.pause(), d(!1);
        },
        onCallAnswered: () => d(!1)
      });
      o(I), $.current = y;
    },
    [i, _, v]
  );
  L(
    () => {
      e && n && l && (async () => {
        const I = await l.start(e, n);
        if (I.isSuccess)
          I.hasConfig ? m(!0) : m(!1);
        else
          switch (I.error) {
            case "GetConfigFailed":
              i.error({
                key: "cc-no-config",
                message: v("notifications.webRtc.message.configFailed"),
                btn: /* @__PURE__ */ t(R, { type: "primary", size: "small", onClick: () => window.location.reload(), children: _ })
              });
              break;
            case "UserConnectFailed":
              i.error({
                key: "cc-connect-user-failed",
                message: v("notifications.webRtc.message.userConnectFailed"),
                btn: /* @__PURE__ */ t(R, { type: "primary", size: "small", onClick: () => window.location.reload(), children: _ })
              });
              break;
          }
      })();
    },
    [n, l, i, _, v, e]
  );
  const H = X(
    () => ({
      isRinging: h,
      webRtcClient: l,
      isRegistered: g,
      isWebRtcUsed: b
    }),
    [l, g, h, b]
  );
  return L(
    () => {
      $.current && ($.current.volume = (s == null ? void 0 : s.ringtoneVolume) ?? 0.5);
    },
    [s == null ? void 0 : s.ringtoneVolume]
  ), /* @__PURE__ */ c(M, { children: [
    /* @__PURE__ */ t("audio", { src: si, ref: w, loop: !0, style: { display: "none" } }),
    l && /* @__PURE__ */ t($e.Provider, { value: H, children: a })
  ] });
}, ci = p.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${(e) => e.theme.paddingLG}px;
`;
function di(e, n, a, i) {
  const { t: r } = E(), { isFocused: s, onFocusRequested: l } = A(se), { conversationId: o } = A(Z), { notificationApi: h, isWindowFocused: d } = A(ze), b = A(ie), { webRtcClient: m, isWebRtcUsed: g } = A($e), u = U(Me), O = `cc-new-conversation-${o}`, N = j(
    () => {
      h.destroy(O);
    },
    [h, O]
  ), k = X(
    () => /* @__PURE__ */ c(M, { children: [
      /* @__PURE__ */ t("div", { children: r("notifications.newConversation.description.fromXCustomerPhoneOnXChannel", { phone: n, channel: a }) }),
      /* @__PURE__ */ t("span", { children: " " }),
      /* @__PURE__ */ t("div", { children: r("notifications.newConversation.description.acceptToAvoidRona") })
    ] }),
    [a, n, r]
  ), T = X(
    () => /* @__PURE__ */ c(ci, { children: [
      /* @__PURE__ */ t(R, { size: "small", type: "link", danger: !0, onClick: () => b.drop({ conversationId: o }), children: r("notifications.newConversation.btnTexts.decline") }),
      g ? /* @__PURE__ */ c(F, { size: "small", children: [
        /* @__PURE__ */ t(R, { size: "small", type: "link", onClick: () => {
          m == null || m.answer(), N();
        }, children: r("notifications.newConversation.btnTexts.accept") }),
        /* @__PURE__ */ t(R, { size: "small", type: "primary", onClick: () => {
          m == null || m.answer(), l();
        }, children: r("notifications.newConversation.btnTexts.acceptAndGoToTask") })
      ] }) : /* @__PURE__ */ t(R, { size: "small", type: "primary", onClick: () => l(), children: r("notifications.newConversation.btnTexts.goToTask") })
    ] }),
    [b, N, o, g, l, r, m]
  );
  zn({ isFocused: s, isWindowFocused: d, isInviting: e, hubState: u, isCallEnded: i }, [
    [() => {
      h.info({
        key: O,
        message: r("notifications.newConversation.title"),
        description: k,
        btn: T,
        style: { width: 450 }
      });
    }, {
      trigger: (v) => v.isInviting && v.hubState === le.Connected && !!n,
      condition: (v) => !v.isFocused || !v.isWindowFocused
    }],
    [N, {
      trigger: (v) => v.isFocused && v.isWindowFocused || v.isCallEnded || !v.isInviting
    }]
  ]);
}
const ui = (e, n, a, i) => {
  if (e) {
    const r = e.participants.find((d) => d.resourceId === n), s = e.participants.filter((d) => d.id !== (r == null ? void 0 : r.id)), l = s == null ? void 0 : s.filter((d) => d.participantType !== x.Supervisor), o = s.find((d) => d.participantType === x.Customer), h = s.find((d) => d.participantType === x.Agent);
    return i ? a ? void 0 : o ? e.isOutbound ? "Outbound" : "Call" : "Consultation" : a ? e.isOutbound && !e.agentToAgentTransferRequestedBy ? "Outbound" : e.agentToAgentTransferRequestedBy ? "Transfer" : h && !o ? "Consultation" : "Call" : e.isOutbound && (l == null ? void 0 : l.length) === 1 ? "Outbound" : l && (l == null ? void 0 : l.length) > 1 ? "Conference" : o ? "Call" : "Consultation";
  }
};
Vn(Ce);
const vn = (e) => {
  const [, n] = V(!0);
  if (L(
    () => {
      const r = setInterval(
        () => n((s) => !s),
        1e3
      );
      return () => clearInterval(r);
    },
    []
  ), !e)
    return null;
  const a = Ce.utc(e);
  return Ce.duration(Ce.utc().diff(a)).format();
}, Q = ({ children: e, overrideTokens: n }) => {
  const { token: a } = tn.useToken();
  return /* @__PURE__ */ t(an, { theme: { token: n(a) }, children: e });
}, Le = 599, Ge = 549, D = {
  underMinWidth: `@container callControlContainer (max-width: ${Le}px)`,
  underMinHeight: `@container callControlContainer (max-height: ${Ge}px)`,
  underMindWidthAndHeight: `@container callControlContainer (max-width: ${Le}px) and (max-height: ${Ge}px)`
}, fn = 216, Cn = 300, bn = (e) => e.controlHeight + 2 * e.paddingXXS, pi = p.div`
  width: 100%;
  height: 100%;
`, hi = p.div`
  width: 100%;
  height: ${(e) => e.$isDirectoryOpen ? `${fn}px` : "100%"};
  
  ${(e) => e.$isDirectoryOpen && te`
    ${D.underMinWidth} {
      height: ${Cn}px;
    }
  `};
`, mi = p.div`
  width: 100%;
  height: ${(e) => bn(e.theme)}px;
`, gi = p.div`
  width: 100%;
  height: calc(100% - ${(e) => bn(e.theme)}px);
`, vi = p.div`
  display: ${(e) => e.$isDirectoryOpen ? "block" : "none"};
  width: 100%;
  height: calc(100% - ${fn}px);

  ${D.underMinWidth} {
    height: calc(100% - ${Cn}px);
  };
`, fi = ({ header: e, call: n, directory: a, isDirectoryOpen: i, expanded: r, isOnHold: s }) => /* @__PURE__ */ c(pi, { children: [
  /* @__PURE__ */ t(Q, { overrideTokens: (l) => ({ colorText: s ? l.colorText : l.colorTextLightSolid }), children: /* @__PURE__ */ c(hi, { $isDirectoryOpen: i, children: [
    /* @__PURE__ */ t(mi, { children: e }),
    r && /* @__PURE__ */ t(gi, { children: n })
  ] }) }),
  /* @__PURE__ */ t(vi, { $isDirectoryOpen: i, children: a })
] }), kn = (e) => e.fontSizeHeading1, Ci = p.div`
  width: 100%;
  height: 100%;
  color: ${(e) => e.theme.colorTextLightSolid};
  background-color: ${(e) => e.theme.colorPrimary};
`, bi = p.div`
  height: ${(e) => kn(e.theme)}px;
`, ki = p.div`
  height: calc(100% - ${(e) => kn(e.theme)}px);
`, Ti = ({ header: e, call: n }) => /* @__PURE__ */ t(Ci, { children: /* @__PURE__ */ c(Q, { overrideTokens: (a) => ({ colorText: a.colorTextLightSolid }), children: [
  /* @__PURE__ */ t(bi, { children: e }),
  /* @__PURE__ */ t(ki, { children: n })
] }) }), _i = p.div`
  padding: ${(e) => e.theme.paddingXXS}px ${(e) => e.theme.paddingXS}px;
  background-color: ${(e) => e.$isOnHold ? e.theme.colorWarning : e.theme.colorPrimary};
  cursor: pointer;
`, wi = p.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${D.underMindWidthAndHeight && D.underMinWidth} {
    justify-content: flex-start;
    gap: ${(e) => e.theme.padding}px;
  }
`, qe = p(R).attrs({ type: "link", icon: /* @__PURE__ */ t(sn, {}) })`
  .ant-btn-icon {
    transform: rotate(${(e) => e.$expanded ? 90 : 0}deg);
    transition: all ${(e) => e.theme.motionDurationMid} ${(e) => e.theme.motionEaseInOut};
    color: ${(e) => e.$isOnHold ? e.theme.colorText : e.theme.colorTextLightSolid};
  }
  padding-right: 0;
  padding-left: 0;
`, ge = p.div`
  color: ${(e) => e.$isOnHold ? e.theme.colorText : e.theme.colorTextLightSolid};
`, Ve = p.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  ${D.underMinWidth} {
    gap: 0px;
  };
`, ve = p(P)`
  ${D.underMinWidth} {
    display: none;
  };
`, Ai = ({ channelName: e, customerName: n, callType: a, isOnHold: i }) => {
  const { expanded: r, onExpandedChangeRequested: s } = A(se), { queueInfo: l } = A(Z), { t: o } = E(), h = a ? a === "Call" ? o("call.inboundCall") : o("callType.", "", { context: a }) : o("callControl"), d = a && a === "Consultation", b = (l == null ? void 0 : l.name) ?? o("misc.unknownQueue");
  return /* @__PURE__ */ t(_i, { id: "cc-call-header", onClick: r ? () => s(!1) : () => s(!0), $isOnHold: i, children: r ? /* @__PURE__ */ c(F, { size: "middle", children: [
    /* @__PURE__ */ t(qe, { $expanded: !0, $isOnHold: i, onClick: () => s(!1), "aria-label": o("header.collapseTitle"), title: o("header.collapseTitle"), children: /* @__PURE__ */ t(P, { strong: !0, children: h }) }),
    !d && /* @__PURE__ */ c(M, { children: [
      /* @__PURE__ */ c(Ve, { children: [
        /* @__PURE__ */ t(ge, { $isOnHold: i, children: /* @__PURE__ */ t(we, { title: o("misc.channelNameX", { value: e }) }) }),
        /* @__PURE__ */ t(ve, { children: e })
      ] }),
      a !== "Outbound" && /* @__PURE__ */ c(Ve, { children: [
        /* @__PURE__ */ t(ge, { $isOnHold: i, children: /* @__PURE__ */ t(He, { title: o("misc.queueNameX", { value: b }) }) }),
        /* @__PURE__ */ t(ve, { children: b })
      ] })
    ] })
  ] }) : /* @__PURE__ */ c(wi, { children: [
    /* @__PURE__ */ c(F, { size: "middle", children: [
      /* @__PURE__ */ t(qe, { $expanded: !1, $isOnHold: i, onClick: () => s(!0), "aria-label": o("header.expandTitle"), title: o("header.expandTitle"), children: /* @__PURE__ */ t(P, { strong: !0, children: h }) }),
      !d && /* @__PURE__ */ c(F, { size: "middle", children: [
        /* @__PURE__ */ t(ge, { $isOnHold: i, children: /* @__PURE__ */ t(we, { title: o("misc.channelNameX", { value: e }) }) }),
        a !== "Outbound" && /* @__PURE__ */ t(ge, { $isOnHold: i, children: /* @__PURE__ */ t(He, { title: o("misc.queueNameX", { value: b }) }) })
      ] })
    ] }),
    /* @__PURE__ */ t(F, { children: !d && /* @__PURE__ */ c(M, { children: [
      a === "Conference" && /* @__PURE__ */ c(ve, { children: [
        n,
        " ",
        o("misc.andOthers"),
        " - ",
        o(i ? "call.onHold" : "call.activeCall")
      ] }),
      (a === "Call" || a === "Outbound") && /* @__PURE__ */ c(ve, { children: [
        n,
        " - ",
        o(i ? "call.onHold" : "call.activeCall")
      ] })
    ] }) })
  ] }) });
}, yi = p.div`
  display: flex;
  flex-direction: row;
  gap: ${(e) => e.theme.padding}px;
  padding: ${(e) => e.theme.paddingXS}px ${(e) => e.theme.padding}px;
`, zi = ({ channelName: e, callType: n }) => {
  const { t: a } = E(), i = n ? n === "Call" ? a("call.inboundCall") : a("callType.", "", { context: n }) : a("callControl");
  return /* @__PURE__ */ c(yi, { children: [
    /* @__PURE__ */ t(P, { strong: !0, children: i }),
    /* @__PURE__ */ c(F, { size: "small", direction: "horizontal", children: [
      /* @__PURE__ */ t(we, { title: a("misc.channelNameX", { value: e }) }),
      /* @__PURE__ */ t(P, { children: e })
    ] })
  ] });
}, xi = p.div`
  padding: ${(e) => e.theme.paddingXXS}px ${(e) => e.theme.paddingXS}px;
  background-color: ${(e) => e.$isOnHold ? e.theme.colorWarning : e.theme.colorPrimary};
  cursor: pointer;
`, Ni = p(R).attrs({ type: "link", icon: /* @__PURE__ */ t(sn, {}) })`
  .ant-btn-icon {
    transform: rotate(${(e) => e.$expanded ? 90 : 0}deg);
    transition: all ${(e) => e.theme.motionDurationMid} ${(e) => e.theme.motionEaseInOut};
    color: ${(e) => e.theme.colorTextLightSolid};
  }
  padding-right: 0;
  padding-left: 0;
`, $i = ({ callType: e, isOnHold: n }) => {
  const { expanded: a, onExpandedChangeRequested: i } = A(se), { t: r } = E(), s = j(
    () => i(!a),
    [a, i]
  );
  return /* @__PURE__ */ t(xi, { id: "cc-preview-header", onClick: s, $isOnHold: n, children: /* @__PURE__ */ c(Ni, { $expanded: a, onClick: s, title: r(a ? "header.collapseTitle" : "header.expandTitle"), children: [
    e === void 0 || e === "Outbound" && /* @__PURE__ */ t(P, { strong: !0, children: r("callControl") }),
    e && e !== "Outbound" && /* @__PURE__ */ t(P, { strong: !0, children: r("preview.incomingX", { value: r("callType.", "", { context: e }) }) })
  ] }) });
}, Ke = ({ text: e, onClick: n, disabled: a, phoneNumbers: i }) => {
  const r = X(
    () => {
      const s = [];
      return i.map((l) => {
        s.push({
          key: `${l.type}-${l.value}`,
          label: l.value,
          icon: l.type === "Mobile" ? /* @__PURE__ */ t(Kn, {}) : /* @__PURE__ */ t(Qn, {}),
          onClick: () => n(l.value)
        });
      }), s;
    },
    [n, i]
  );
  return i.length > 1 ? /* @__PURE__ */ t(jn, { menu: { items: r }, children: /* @__PURE__ */ t(
    R,
    {
      type: "primary",
      size: "small",
      disabled: a,
      children: e
    }
  ) }) : /* @__PURE__ */ t(
    R,
    {
      type: "primary",
      size: "small",
      disabled: a,
      onClick: () => n(i[0].value),
      children: e
    }
  );
}, Si = /^\+?\d+$/, Di = ({ onCloseDirectory: e }) => {
  const { apiBaseUrl: n, token: a, language: i, displaySettings: { hideExternalContacts: r } } = A(ze), { conversationId: s, businessUnitId: l } = A(Z), o = A(ie), { t: h } = E(), [d, b] = V(""), m = X(
    () => Si.test(d),
    [d]
  ), g = h("actions.btnTitles._Transfer"), u = h("actions.btnTitles.consult"), O = j(
    (w) => [
      /* @__PURE__ */ c(M, { children: [
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            disabled: w.status !== "Idle",
            onClick: () => {
              o.transferTo({ conversationId: s, agentId: w.id }), e();
            },
            children: g
          }
        ),
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            disabled: w.status !== "Idle",
            onClick: () => {
              o.consultWith({ conversationId: s, targetResourceId: w.id }), e();
            },
            children: u
          }
        )
      ] })
    ],
    [o, u, s, e, g]
  ), N = j(
    (w) => [
      /* @__PURE__ */ c(M, { children: [
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            onClick: () => {
              o.transferTo({ conversationId: s, channelId: w.id }), e();
            },
            children: g
          }
        ),
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            onClick: () => {
              o.consultWith({ conversationId: s, channelId: w.id }), e();
            },
            children: u
          }
        )
      ] })
    ],
    [o, u, s, e, g]
  ), k = X(
    () => ({ actions: (H) => {
      var y, I;
      return [
        /* @__PURE__ */ c(M, { children: [
          /* @__PURE__ */ t(
            Ke,
            {
              text: g,
              disabled: ((y = H.phones) == null ? void 0 : y.length) === 0,
              phoneNumbers: H.phones ?? [],
              onClick: (Y) => {
                o.transferTo({ conversationId: s, phone: Y }), e();
              }
            }
          ),
          /* @__PURE__ */ t(
            Ke,
            {
              text: u,
              disabled: ((I = H.phones) == null ? void 0 : I.length) === 0,
              phoneNumbers: H.phones ?? [],
              onClick: (Y) => {
                o.consultWith({ conversationId: s, externalContact: { phoneNumber: Y } }), e();
              }
            }
          )
        ] })
      ];
    } }),
    [o, u, s, e, g]
  ), T = j(
    (w) => [
      /* @__PURE__ */ c(M, { children: [
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            onClick: () => {
              o.transferTo({ conversationId: s, phone: w.phoneNumber }), e();
            },
            children: g
          }
        ),
        /* @__PURE__ */ t(
          R,
          {
            type: "primary",
            size: "small",
            onClick: () => {
              o.consultWith({ conversationId: s, externalContact: { phoneNumber: w.phoneNumber || "" } }), e();
            },
            children: u
          }
        )
      ] })
    ],
    [o, u, s, e, g]
  ), $ = j(
    () => {
      o.consultWith({ conversationId: s, externalContact: { phoneNumber: d } }), e();
    },
    [o, s, e, d]
  ), v = j(
    () => {
      o.transferTo({ conversationId: s, phone: d }), e();
    },
    [o, s, e, d]
  ), _ = j(
    (w) => {
      w.preventDefault();
      const y = w.clipboardData.getData("Text").replace(/\s/g, "");
      b(y);
    },
    []
  );
  return /* @__PURE__ */ t(
    ot,
    {
      apiBaseUrl: n,
      token: a,
      mediaGroup: "voice",
      businessUnitId: l,
      language: i,
      agentsTab: {
        actions: O
      },
      channelsTab: {
        actions: N
      },
      internalContactsTab: r ? void 0 : k,
      contactDirectoryTab: {
        actions: T
      },
      extraTabs: [{
        label: h("dialOut.label"),
        children: /* @__PURE__ */ c(F, { size: "middle", wrap: !0, children: [
          /* @__PURE__ */ c(P, { children: [
            h("dialOut.phoneNumber"),
            ":"
          ] }),
          /* @__PURE__ */ t(
            In,
            {
              placeholder: h("dialOut.placeHolder"),
              value: d,
              onChange: (w) => b(w.target.value),
              maxLength: 30,
              status: d.length === 0 ? "warning" : m ? void 0 : "error",
              style: { width: "260px" },
              onPaste: _
            }
          ),
          /* @__PURE__ */ t(
            R,
            {
              type: "primary",
              onClick: $,
              disabled: !m,
              children: u
            }
          ),
          /* @__PURE__ */ t(
            R,
            {
              type: "primary",
              onClick: v,
              disabled: !m || d.length === 0,
              children: g
            }
          )
        ] })
      }]
    }
  );
}, Tn = ({ onClick: e }) => {
  const { t: n } = E();
  return /* @__PURE__ */ t(Q, { overrideTokens: (a) => ({ colorBgContainer: a.colorSuccess, lineWidth: 0 }), children: /* @__PURE__ */ t(
    R,
    {
      id: "accept-btn",
      size: "large",
      shape: "circle",
      title: n("actions.btnTooltips.accept"),
      icon: /* @__PURE__ */ t(Zn, {}),
      onClick: e
    }
  ) });
}, Ri = p.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `, Ue = () => /* @__PURE__ */ t(Ri, { children: /* @__PURE__ */ t(Fn, { size: "large" }) }), Hi = () => /* @__PURE__ */ t("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "currentcolor", children: /* @__PURE__ */ t("g", { transform: "matrix(-0.658808,-0.658808,0.658808,-0.658808,5.99952,13.9068)", children: /* @__PURE__ */ t("path", { d: "M10.89,2.34L9.463,0.915C9.289,0.741 9.056,0.643 8.81,0.643C8.563,0.643 8.33,0.739 8.156,0.915L6.62,2.448C6.446,2.622 6.348,2.857 6.348,3.103C6.348,3.351 6.445,3.583 6.62,3.758L7.82,4.959C7.547,5.596 7.154,6.175 6.663,6.664C6.171,7.158 5.597,7.548 4.959,7.824L3.759,6.623C3.585,6.449 3.352,6.351 3.106,6.351C2.86,6.35 2.625,6.448 2.452,6.623L0.915,8.156C0.741,8.33 0.643,8.565 0.643,8.811C0.643,9.059 0.739,9.291 0.915,9.466L2.34,10.891C2.637,11.188 3.047,11.358 3.467,11.358C3.554,11.358 3.639,11.352 3.725,11.337C5.498,11.045 7.258,10.101 8.679,8.681C10.098,7.259 11.041,5.499 11.336,3.725C11.42,3.221 11.251,2.703 10.89,2.34ZM10.386,3.565C10.125,5.144 9.276,6.719 7.997,7.998C6.718,9.277 5.144,10.126 3.565,10.387C3.367,10.421 3.163,10.354 3.019,10.211L1.619,8.811L3.103,7.326L4.708,8.933L4.72,8.945L5.009,8.838C6.783,8.186 8.184,6.785 8.835,5.01L8.942,4.721L7.325,3.104L8.808,1.619L10.208,3.019C10.353,3.163 10.42,3.367 10.386,3.565Z", style: { fillRule: "nonzero" } }) }) }), Oi = (e) => /* @__PURE__ */ t(ln, { ...e, component: Hi }), ye = ({ onClick: e }) => {
  const { t: n } = E();
  return /* @__PURE__ */ t(
    R,
    {
      id: "drop-btn",
      danger: !0,
      type: "primary",
      size: "large",
      shape: "circle",
      icon: /* @__PURE__ */ t(Oi, {}),
      title: n("actions.btnTooltips.drop"),
      onClick: e
    }
  );
}, ue = ({ participantType: e, name: n, phone: a }) => /* @__PURE__ */ c(F, { children: [
  /* @__PURE__ */ t(Q, { overrideTokens: (i) => ({ colorTextPlaceholder: e === "Customer" ? i.colorTextPlaceholder : i.colorPrimaryText }), children: /* @__PURE__ */ t(Mn, { icon: /* @__PURE__ */ t(Yn, {}), size: "large" }) }),
  /* @__PURE__ */ c(F, { direction: "vertical", size: 4, children: [
    /* @__PURE__ */ t(P, { strong: !0, children: n }),
    /* @__PURE__ */ t(P, { children: a })
  ] })
] }), Qe = p.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.paddingLG}px;
`, ji = p.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.controlHeightLG}px;
`, Ii = p.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: ${(e) => e.theme.paddingLG}px;
`, Fi = p.div`
  display: flex;
  gap: ${(e) => e.theme.controlHeightLG * 2}px;
`, Mi = p(fe.Group)`
  .ant-radio-button-wrapper {
    color: ${(e) => e.theme.colorText}
  }
  .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
    color: ${(e) => e.theme.colorTextLightSolid};
    background-color: ${(e) => e.theme.colorPrimaryTextHover};
    border-color: ${(e) => e.theme.colorPrimaryTextHover};
  }
`, Pi = ({ isInviting: e, participants: n, elapsedCallTime: a }) => {
  const { supervisorMode: i } = A(se), { conversationId: r } = A(Z), s = A(ie), { isRinging: l, webRtcClient: o, isRegistered: h, isWebRtcUsed: d } = A($e), { t: b } = E(), m = U(Ne(r)), g = U(Pe), u = U(Me), O = U(Be), N = m == null ? void 0 : m.participants.find((_) => _.resourceId === g), k = !O.includes(r) && (!m || !N), T = O.includes(r) && (!m || !N), $ = j(
    (_) => !(m != null && m.capabilities.includes(_)),
    [m == null ? void 0 : m.capabilities]
  );
  L(
    () => {
      if (r && i && !T && u === le.Connected) {
        if (d === void 0)
          return;
        d ? h && s.monitor({ conversationId: r }) : s.monitor({ conversationId: r });
      }
    },
    [s, r, u, T, h, d, i]
  ), L(
    () => {
      l && (o == null || o.answer());
    },
    [l, o]
  );
  const v = j(
    () => o == null ? void 0 : o.answer(),
    [o]
  );
  return k ? /* @__PURE__ */ t(Q, { overrideTokens: (_) => ({ colorPrimary: _.colorBgContainer }), children: /* @__PURE__ */ t(Ue, {}) }) : T ? /* @__PURE__ */ t(Qe, { children: /* @__PURE__ */ t(Ae, { level: 2, children: b("call.ended") }) }) : /* @__PURE__ */ t(Qe, { children: e ? /* @__PURE__ */ c(ji, { children: [
    /* @__PURE__ */ t(Ae, { level: 2, children: b("misc.initMonitoringCall") }),
    /* @__PURE__ */ c(Fi, { children: [
      /* @__PURE__ */ t(ye, { onClick: () => s.drop({ conversationId: r }) }),
      l && /* @__PURE__ */ t(Tn, { onClick: v })
    ] })
  ] }) : /* @__PURE__ */ c(M, { children: [
    /* @__PURE__ */ t(Ii, { children: n.map((_) => /* @__PURE__ */ t(
      ue,
      {
        name: _.name,
        participantType: _.participantType,
        phone: _.phone
      },
      _.phone
    )) }),
    /* @__PURE__ */ c(F, { direction: "vertical", size: "large", align: "center", children: [
      a && /* @__PURE__ */ c(P, { children: [
        b("call.activeCall"),
        " - ",
        a
      ] }),
      /* @__PURE__ */ c(Mi, { defaultValue: "monitor", buttonStyle: "solid", children: [
        /* @__PURE__ */ t(
          fe.Button,
          {
            value: "monitor",
            disabled: $(z.Monitor),
            onClick: () => s.monitor({ conversationId: r }),
            children: b("actions.supervisorActionBtnTexts.monitor")
          }
        ),
        /* @__PURE__ */ t(
          fe.Button,
          {
            value: "whisper",
            disabled: $(z.Whisper),
            onClick: () => s.whisper({ conversationId: r }),
            children: b("actions.supervisorActionBtnTexts.whisper")
          }
        ),
        /* @__PURE__ */ t(
          fe.Button,
          {
            value: "barge-in",
            disabled: $(z.BargeIn),
            onClick: () => s.bargeIn({ conversationId: r }),
            children: b("actions.supervisorActionBtnTexts.bargeIn")
          }
        )
      ] }),
      /* @__PURE__ */ t(ye, { onClick: () => s.drop({ conversationId: r }) })
    ] })
  ] }) });
}, Bi = () => /* @__PURE__ */ t("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "currentcolor", children: /* @__PURE__ */ c("g", { transform: "matrix(1.35216,0,0,1.35216,-2.11299,-2.11351)", children: [
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,0,-1.21572)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,0,-3.67394)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,2.49057,-1.21572)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,-2.49057,-1.21572)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,-2.49057,-3.67394)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,2.49057,-3.67394)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,2.49057,1.2425)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,0,1.2425)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,-2.49057,1.2425)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) }),
  /* @__PURE__ */ t("g", { transform: "matrix(1,0,0,1,0,3.70072)", children: /* @__PURE__ */ t("path", { d: "M5.25,5.987C5.25,6.398 5.589,6.737 6,6.737C6.411,6.737 6.75,6.398 6.75,5.987C6.75,5.575 6.411,5.237 6,5.237C5.589,5.237 5.25,5.575 5.25,5.987Z" }) })
] }) }), Ui = (e) => /* @__PURE__ */ t(ln, { ...e, component: Bi }), Xi = (e) => {
  switch (e) {
    case "OpenDialpad":
      return /* @__PURE__ */ t(Ui, {});
    case "Mute":
      return /* @__PURE__ */ t(it, {});
    case "Unmute":
      return /* @__PURE__ */ t(tt, {});
    case "Hold":
      return /* @__PURE__ */ t(We, {});
    case "Unhold":
      return /* @__PURE__ */ t(We, {});
    case "Transfer":
      return /* @__PURE__ */ t(nt, {});
    case "AddToCall":
      return /* @__PURE__ */ t(et, {});
    case "OpenDirectory":
      return /* @__PURE__ */ t(Jn, {});
  }
}, Wi = p.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.sizeXXS}px;
`, ne = ({ buttonType: e, isBtnActive: n, onClick: a }) => {
  const { t: i } = E(), [r, s] = V(n ?? !1);
  L(
    () => {
      n !== void 0 && s(n);
    },
    [n]
  );
  const l = X(
    () => e === "Unhold" ? i("actions.btnTitles._Hold") : e === "Unmute" ? i("actions.btnTitles._Mute") : i("actions.btnTitles.", "", { context: e }),
    [e, i]
  ), o = X(
    () => e === "OpenDialpad" && r ? i("actions.btnTooltips.closeDialpad") : e === "OpenDirectory" && r ? i("actions.btnTooltips.closeDirectory") : i("actions.btnTooltips.", "", { context: e }),
    [e, r, i]
  ), h = j(
    () => {
      a(), s(!r);
    },
    [r, a]
  );
  return /* @__PURE__ */ c(Wi, { children: [
    /* @__PURE__ */ t(Q, { overrideTokens: (d) => ({
      colorText: r ? d.colorBgContainer : d.colorPrimary,
      colorBgContainer: r ? d.colorPrimaryTextHover : d.colorBgContainer,
      lineWidth: 0
    }), children: /* @__PURE__ */ t(R, { size: "large", shape: "circle", icon: Xi(e), onClick: h, title: o }) }),
    /* @__PURE__ */ t(P, { style: { fontSize: "12px" }, children: l })
  ] });
}, Ei = ({ text: e, onClick: n }) => /* @__PURE__ */ t(Q, { overrideTokens: (a) => ({
  colorText: a.colorPrimary,
  colorBgContainer: a.colorBgContainer,
  lineWidth: 0,
  fontSize: a.paddingLG
}), children: /* @__PURE__ */ t(R, { size: "large", shape: "circle", onClick: n, children: e }) }), Li = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"], Gi = p.div`
  background-color: inherit;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
  vertical-align: middle;
  grid-gap: ${(e) => e.theme.padding}px;
`, qi = ({ onClick: e }) => /* @__PURE__ */ t(Gi, { children: Li.map(
  (n) => /* @__PURE__ */ t(
    Ei,
    {
      text: n,
      onClick: () => e(n)
    },
    n
  )
) }), Vi = p.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: ${(e) => e.$isDirectoryOpen ? "row" : "column"};
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.$isDirectoryOpen ? e.theme.controlHeightLG : e.theme.paddingLG}px;
  background-color: ${(e) => e.$isOnHold ? e.theme.colorWarning : e.theme.colorPrimary};
  
  ${D.underMindWidthAndHeight} {
    width: auto;
    padding: 0 ${(e) => e.theme.paddingMD}px;
    gap: ${(e) => e.theme.paddingXL}px !important;
  }

  ${(e) => e.$isDirectoryOpen ? te`
      ${D.underMinWidth} {
        flex-direction: column;
        gap: ${e.theme.paddingLG}px;
      };
    ` : te`
      ${D.underMinWidth} {
        flex-direction: column;
      };
    `}

  ${(e) => e.$isDialpadOpen ? te`
      ${D.underMinHeight} {
       flex-direction: row-reverse;
       gap: ${e.theme.controlHeightLG}px;
      }
    ` : te`
      ${D.underMinHeight} {
       flex-direction: row;
       gap: ${e.theme.controlHeightLG}px;
      }
    `}
`, Ki = p.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: ${(e) => e.theme.paddingLG}px;

  ${(e) => e.$isDirectoryOpen ? te`
    ${D.underMinWidth} {
      flex-direction: row;
      align-items: flex-start;
      };
    ` : te`
    ${D.underMinWidth} {
      flex-direction: column;
      align-items: flex-start;
    };
  `}

  ${D.underMinHeight} {
    flex-direction: column;
    align-items: flex-start;
  };

  ${(e) => e.$isDialpadOpen && te`
     ${D.underMinHeight} {
      display: none;
    };
  `}
`, Qi = p.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.padding}px;
  
  ${D.underMindWidthAndHeight} {
    max-width: 50%;
  }
`, Zi = p.div`
  ${D.underMindWidthAndHeight} {
    display: none;
  }
`, Yi = p.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-rows: 1fr;
  grid-auto-columns: 1fr;
  grid-gap: ${(e) => e.theme.padding}px;
  
  ${D.underMindWidthAndHeight} {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  };
`, Ji = ({ callType: e, participants: n, elapsedCallTime: a, isOnHold: i, isDirectoryOpen: r, onToggleDirectory: s }) => {
  const { conversationId: l } = A(Z), o = A(ie), { isPredictive: h, primaryChannelType: d } = A(Je), { t: b } = E(), [m, g] = V(!1), u = U(Ne(l)), O = U(mn), N = U(Be), k = U(Pe), T = u == null ? void 0 : u.participants.find((S) => S.resourceId === k), $ = u == null ? void 0 : u.participants.some((S) => S.participantType === x.Customer), v = O.filter((S) => S.participants.some((oe) => oe.resourceId === k)).length === 1, _ = N.includes(l) && (!u || !T), w = !N.includes(l) && (!u || !T), H = u == null ? void 0 : u.participants.find((S) => S.participantType === x.Customer), y = e === "Outbound" && (H == null ? void 0 : H.state) === W.Inviting, { data: I } = dt({ conversationId: l, businessUnitId: (u == null ? void 0 : u.businessUnitId) ?? null }), Y = (I == null ? void 0 : I.featureAvailable) && $, [G] = ut(), ae = j(
    (S, oe) => oe.find((wn) => wn.id !== S),
    []
  ), q = j(
    (S) => (u == null ? void 0 : u.capabilities.includes(S)) ?? !1,
    [u == null ? void 0 : u.capabilities]
  ), B = h || d === "virtual", J = q(z.DTMF) && !r, ce = q(z.Mute) && (T == null ? void 0 : T.state) !== W.Muted && !y, Se = q(z.Unmute) && (T == null ? void 0 : T.state) === W.Muted && !y, De = q(z.HoldCall) && (T == null ? void 0 : T.state) !== W.Hold && !y, f = q(z.UnholdCall) && (T == null ? void 0 : T.state) === W.Hold && !y, ee = v && $ && !m && e !== "Conference" && !y && !B, pe = q(z.CompleteConference) && !y, he = q(z.CompleteTransfer) && !y, me = q(z.DropCall) && !m && !r, K = j(
    (S) => {
      var oe;
      o.completeConsult({
        customerConversationId: ((oe = ae(l, O)) == null ? void 0 : oe.id) || "",
        consultConversationId: l,
        isConference: S
      });
    },
    [o, O, l, ae]
  );
  return /* @__PURE__ */ t(Vi, { $isDialpadOpen: m, $isDirectoryOpen: r, $isOnHold: i, children: _ ? /* @__PURE__ */ t(Ae, { level: 2, children: b("call.ended") }) : /* @__PURE__ */ t(M, { children: w ? /* @__PURE__ */ t(Q, { overrideTokens: (S) => ({ colorPrimary: S.colorBgContainer }), children: /* @__PURE__ */ t(Ue, {}) }) : /* @__PURE__ */ c(M, { children: [
    y && /* @__PURE__ */ t(Ae, { level: 2, children: b("call.calling") }),
    /* @__PURE__ */ t(Ki, { $isDialpadOpen: m, $isDirectoryOpen: r, children: n.map((S) => /* @__PURE__ */ t(
      ue,
      {
        name: S.name,
        phone: S.phone,
        participantType: S.participantType
      },
      S.phone
    )) }),
    /* @__PURE__ */ c(Qi, { id: "controls-container", children: [
      a && /* @__PURE__ */ c(P, { children: [
        b(i ? "call.callOnHold" : "call.activeCall"),
        " - ",
        a
      ] }),
      Y && /* @__PURE__ */ t(Zi, { children: /* @__PURE__ */ c(F, { direction: "horizontal", children: [
        /* @__PURE__ */ t(P, { children: b("call.recording") }),
        /* @__PURE__ */ t(Q, { overrideTokens: (S) => ({ colorPrimary: S.colorSuccess }), children: /* @__PURE__ */ t(
          Pn,
          {
            size: "small",
            onChange: (S) => G({ conversationId: l, isEnabled: S }),
            disabled: I.disableAgentControl,
            defaultChecked: !I.discardRecording,
            title: b("call.recordingToggle")
          }
        ) })
      ] }) }),
      /* @__PURE__ */ c(F, { size: "middle", direction: "vertical", align: "center", wrap: !0, children: [
        T && /* @__PURE__ */ c(Yi, { children: [
          J && /* @__PURE__ */ t(ne, { buttonType: "OpenDialpad", onClick: () => g(!m) }),
          ce && /* @__PURE__ */ t(ne, { buttonType: "Mute", onClick: () => o.mute({ participantId: T.id, conversationId: l }) }),
          Se && /* @__PURE__ */ t(ne, { buttonType: "Unmute", onClick: () => o.unmute({ participantId: T.id, conversationId: l }), isBtnActive: !0 }),
          De && /* @__PURE__ */ t(ne, { buttonType: "Hold", onClick: () => o.hold({ conversationId: l }) }),
          f && /* @__PURE__ */ t(ne, { buttonType: "Unhold", onClick: () => o.unhold({ conversationId: l }), isBtnActive: !0 }),
          ee && /* @__PURE__ */ t(ne, { buttonType: "OpenDirectory", onClick: s, isBtnActive: r }),
          pe && /* @__PURE__ */ t(ne, { buttonType: "AddToCall", onClick: () => K(!0) }),
          he && /* @__PURE__ */ t(ne, { buttonType: "Transfer", onClick: () => K(!1) })
        ] }),
        me && /* @__PURE__ */ t(ye, { onClick: () => o.drop({ conversationId: l }) })
      ] })
    ] }),
    m && !r && /* @__PURE__ */ t(qi, { onClick: (S) => o.playTouchTone({ conversationId: l, tone: S }) })
  ] }) }) });
}, ea = (e, n) => e.participantType === x.Agent && n.participantType !== x.Agent ? -1 : e.participantType !== x.Agent && n.participantType === x.Agent ? 1 : 0, na = p.div`
  width: 100%;
  height: 100%;
  background-color: ${(e) => e.theme.colorPrimary};
`, ta = p.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.controlHeightLG}px;

  ${D.underMinHeight} {
    gap: ${(e) => e.theme.controlHeightXS}px;
  }
`, ia = p.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${(e) => e.theme.padding}px;
  
 ${D.underMinWidth} {
  flex-direction: column;
 }
`, Ze = p.div`
  font-size: ${(e) => e.theme.paddingLG}px;
  color: ${(e) => e.theme.colorTextLightSolid};

  ${D.underMinHeight} {
    font-size: ${(e) => e.theme.paddingMD}px;
  }
`, aa = p(at)`
  color: ${(e) => e.theme.colorTextLightSolid};
  font-size: ${(e) => e.theme.sizeLG}px;

   ${D.underMinWidth} {
     transform: rotate(90deg);
   }
`, oa = p.div`
  display: flex;
  gap: ${(e) => e.theme.controlHeightLG * 2}px;
`, Xe = p(P)`
  ${D.underMinHeight} {
    line-height: 1.2 !important;
  }
`, Ye = p(Xe)`
  font-size: ${(e) => e.theme.fontSizeHeading2}px;

  ${D.underMinHeight} {
    font-size: ${(e) => e.theme.fontSizeHeading3}px;
  }
`, ra = p(Xe)`
  font-size: ${(e) => e.theme.fontSizeHeading3}px;
  
  ${D.underMinHeight} {
    font-size: ${(e) => e.theme.fontSizeHeading4}px;
  }
`, la = p(Xe)`
  font-size: ${(e) => e.theme.fontSizeHeading4}px;

  ${D.underMinHeight} {
    font-size: ${(e) => e.theme.fontSizeHeading5}px;
  }
`, sa = ({ callType: e, participants: n }) => {
  var g, u, O, N;
  const { conversationId: a, queueInfo: i } = A(Z), r = A(ie), { isRinging: s, webRtcClient: l } = A($e), { t: o } = E(), h = U(Ne(a)), d = e === void 0 ? "" : o("callType.", "", { context: e }), b = vn((i == null ? void 0 : i.queuedAt) ?? "");
  L(
    () => {
      e === "Outbound" && s && (l == null || l.answer());
    },
    [e, s, l]
  ), L(
    () => {
      e !== "Outbound" && (l != null && l.autoAnswerEnabled) && s && (l == null || l.answer());
    },
    [e, s, l]
  );
  const m = j(
    () => l == null ? void 0 : l.answer(),
    [l]
  );
  return /* @__PURE__ */ t(na, { id: "preview-container", children: h ? /* @__PURE__ */ c(ta, { children: [
    e === "Outbound" ? /* @__PURE__ */ t(Ye, { children: o("preview.initiating") }) : /* @__PURE__ */ c(M, { children: [
      /* @__PURE__ */ t(Ye, { children: o("preview.incomingX", { value: d }) }),
      /* @__PURE__ */ c(F, { direction: "vertical", align: "center", children: [
        /* @__PURE__ */ t(F, { direction: "vertical", size: "small", align: "center", children: /* @__PURE__ */ c(F, { children: [
          /* @__PURE__ */ t(Ze, { children: /* @__PURE__ */ t(we, {}) }),
          /* @__PURE__ */ t(ra, { children: (h == null ? void 0 : h.channelName) ?? o("misc.unknownChannel") })
        ] }) }),
        /* @__PURE__ */ t(F, { direction: "vertical", size: "small", align: "center", children: /* @__PURE__ */ c(F, { children: [
          /* @__PURE__ */ t(Ze, { children: /* @__PURE__ */ t(He, {}) }),
          /* @__PURE__ */ t(la, { children: (i == null ? void 0 : i.name) ?? o("misc.unknownQueue") })
        ] }) }),
        /* @__PURE__ */ c(P, { children: [
          o("preview.waitTimeText"),
          " - ",
          b
        ] })
      ] }),
      /* @__PURE__ */ t(ia, { children: e === "Transfer" ? /* @__PURE__ */ c(M, { children: [
        /* @__PURE__ */ t(
          ue,
          {
            participantType: x.Agent,
            name: ((g = n.find((k) => k.participantType === x.Agent)) == null ? void 0 : g.name) ?? o("misc.unknownAgent"),
            phone: ((u = n.find((k) => k.participantType === x.Agent)) == null ? void 0 : u.phone) ?? o("misc.unknownPhone")
          }
        ),
        /* @__PURE__ */ t(aa, {}),
        /* @__PURE__ */ t(
          ue,
          {
            participantType: x.Customer,
            name: ((O = n.find((k) => k.participantType === x.Customer)) == null ? void 0 : O.name) ?? o("misc.unknownCustomer"),
            phone: ((N = n.find((k) => k.participantType === x.Customer)) == null ? void 0 : N.phone) ?? o("misc.unknownPhone")
          }
        )
      ] }) : /* @__PURE__ */ t(M, { children: n.sort(ea).map((k) => /* @__PURE__ */ t(
        ue,
        {
          participantType: k.participantType,
          name: k.name,
          phone: k.phone
        },
        k.phone
      )) }) })
    ] }),
    /* @__PURE__ */ c(oa, { children: [
      /* @__PURE__ */ t(ye, { onClick: () => r.drop({ conversationId: a }) }),
      s && /* @__PURE__ */ t(Tn, { onClick: m })
    ] })
  ] }) : /* @__PURE__ */ t(Q, { overrideTokens: (k) => ({ colorPrimary: k.colorBgContainer }), children: /* @__PURE__ */ t(Ue, {}) }) });
}, ca = () => {
  const { supervisorMode: e, expanded: n, onExtraHeightRequested: a } = A(se), { conversationId: i } = A(Z), { t: r } = E(), [s, l] = V(!1), o = U(Ne(i)), h = U(mn), d = U(Be), b = U(Pe), m = U(Me), g = o == null ? void 0 : o.participants.find((f) => f.resourceId === b), u = h.filter((f) => f.participants.some((ee) => ee.resourceId === b)).length === 1, O = d.includes(i) && (!o || !g), N = (g == null ? void 0 : g.state) === W.Inviting, k = (g == null ? void 0 : g.state) === W.Hold, T = vn(g == null ? void 0 : g.joinedAt), $ = o == null ? void 0 : o.participants.filter((f) => f.id !== (g == null ? void 0 : g.id)), v = $ == null ? void 0 : $.find((f) => f.participantType === x.Customer), _ = $ == null ? void 0 : $.find((f) => f.participantType === x.External), w = $ == null ? void 0 : $.find((f) => f.participantType === x.Agent), H = $ == null ? void 0 : $.find((f) => f.participantType === x.Supervisor), y = X(
    () => ui(o, b, N, e ?? !1),
    [e, o, N, b]
  ), { customerId: I, customerPhone: Y } = X(
    () => {
      if (v) {
        const f = v.resourceId ?? "", ee = v.number;
        return { customerId: f, customerPhone: ee };
      }
      return { customerId: "", customerPhone: "" };
    },
    [v]
  ), { data: G } = st(I, { skip: !I }), ae = (o == null ? void 0 : o.channelName) ?? r("misc.unknownChannel");
  di(N, v == null ? void 0 : v.number, ae, O);
  const q = X(
    () => {
      const f = [];
      return w && f.push(w.resourceId ?? ""), H && f.push(H.resourceId ?? ""), o != null && o.agentToAgentTransferRequestedBy && N && f.push(o.agentToAgentTransferRequestedBy ?? ""), f;
    },
    [w, o == null ? void 0 : o.agentToAgentTransferRequestedBy, N, H]
  ), { users: B } = pt(q, {
    skip: q.length === 0,
    selectFromResult: ({ data: f }) => ({ users: f == null ? void 0 : f.results })
  }), { data: J } = ct((_ == null ? void 0 : _.resourceId) ?? "", { skip: !(_ != null && _.resourceId) }), ce = X(
    () => {
      var ee, pe, he, me;
      const f = [];
      return v && f.push({
        participantType: x.Customer,
        name: (G == null ? void 0 : G.name) ?? r("misc.unknownCustomer"),
        phone: Y
      }), _ && f.push({
        participantType: x.External,
        name: (J == null ? void 0 : J.name) ?? r("misc.unknownParticipant"),
        phone: _.number
      }), w && f.push({
        participantType: x.Agent,
        name: ((ee = B == null ? void 0 : B.find((K) => K.id === (w == null ? void 0 : w.resourceId))) == null ? void 0 : ee.name) ?? r("misc.unknownAgent"),
        phone: w.number
      }), H && H.supervisorState !== de.Monitor && f.push({
        participantType: x.Supervisor,
        name: ((pe = B == null ? void 0 : B.find((K) => K.id === (H == null ? void 0 : H.resourceId))) == null ? void 0 : pe.name) ?? r("misc.unknownSupervisor"),
        phone: H.number
      }), o != null && o.agentToAgentTransferRequestedBy && N && f.push({
        participantType: x.Agent,
        name: ((he = B == null ? void 0 : B.find((K) => K.id === (o == null ? void 0 : o.agentToAgentTransferRequestedBy))) == null ? void 0 : he.name) ?? r("misc.unknownAgent"),
        phone: ((me = B == null ? void 0 : B.find((K) => K.id === (o == null ? void 0 : o.agentToAgentTransferRequestedBy))) == null ? void 0 : me.phoneNumber) ?? r("misc.unknownPhone")
      }), f;
    },
    [w, o == null ? void 0 : o.agentToAgentTransferRequestedBy, G == null ? void 0 : G.name, v, Y, J == null ? void 0 : J.name, _, N, H, r, B]
  );
  L(
    () => {
      i && m === le.Connected && je.peek({ conversationId: i });
    },
    [i, m]
  );
  const Se = j(
    () => {
      l(!s), s || a();
    },
    [s, a]
  ), De = j(
    () => {
      l(!1);
    },
    []
  );
  return /* @__PURE__ */ c(M, { children: [
    e ? /* @__PURE__ */ t(
      Ti,
      {
        header: /* @__PURE__ */ t(
          zi,
          {
            channelName: ae,
            callType: y
          }
        ),
        call: /* @__PURE__ */ t(
          Pi,
          {
            isInviting: N,
            participants: ce,
            elapsedCallTime: T ?? ""
          }
        )
      }
    ) : /* @__PURE__ */ t(
      fi,
      {
        expanded: n,
        isOnHold: k,
        header: N ? /* @__PURE__ */ t(
          $i,
          {
            isOnHold: k,
            callType: y
          }
        ) : /* @__PURE__ */ t(
          Ai,
          {
            callType: y,
            channelName: ae,
            customerName: (G == null ? void 0 : G.name) ?? r("misc.unknownCustomer"),
            isOnHold: k
          }
        ),
        call: N ? /* @__PURE__ */ t(
          sa,
          {
            participants: ce,
            callType: y
          }
        ) : /* @__PURE__ */ t(
          Ji,
          {
            callType: y,
            participants: ce,
            elapsedCallTime: T ?? "",
            isOnHold: k,
            isDirectoryOpen: s,
            onToggleDirectory: Se
          }
        ),
        directory: /* @__PURE__ */ t(
          Di,
          {
            onCloseDirectory: De
          }
        ),
        isDirectoryOpen: s && u
      }
    ),
    ";"
  ] });
}, da = p.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`, ua = ({ children: e }) => {
  const { conversationId: n } = A(Z), a = A(ie), { t: i } = E(), [r, s] = V(null);
  return L(
    () => a.onError((l) => {
      s(l), setTimeout(() => s(null), 7e3);
    }),
    [a]
  ), /* @__PURE__ */ c(M, { children: [
    e,
    r && r.conversationId === n && /* @__PURE__ */ t(da, { children: /* @__PURE__ */ t(
      Bn,
      {
        type: "error",
        message: r.errorType ? i("failure.title.", "", { context: r.errorType }) ?? r.errorType : i("failure.details._GenericUnspecified"),
        description: r.reasonCode ? i("failure.details.", "", { context: r.reasonCode }) ?? r.reasonCode : "",
        closable: !0,
        onClose: () => s(null)
      }
    ) })
  ] });
}, pa = Dn`  
  .ant-typography {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  #controls-container, #drop-btn, #accept-btn {
    .ant-btn, .ant-btn-circle, .ant-btn-icon, .ant-btn-icon-only, .anticon {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      font-size: 24px !important;
    }
  }
`, ha = ({ children: e }) => {
  const { token: n } = tn.useToken();
  return /* @__PURE__ */ t(Rn, { theme: n, children: e });
}, ma = ({ children: e, theme: n }) => /* @__PURE__ */ t(an, { theme: n, children: /* @__PURE__ */ c(ha, { children: [
  /* @__PURE__ */ t(pa, {}),
  e
] }) }), ga = ({ language: e, children: n }) => {
  const a = X(
    () => {
      const i = rn.createInstance();
      return i.use(nn).init({
        resources: gn,
        lng: e,
        fallbackLng: "en-US",
        interpolation: {
          escapeValue: !1
        }
      }), i;
    },
    [e]
  );
  return /* @__PURE__ */ t(On, { i18n: a, children: n });
};
function va({ children: e, ...n }) {
  const { apiBaseUrl: a, token: i, language: r } = A(ze), s = hn();
  return L(
    () => {
      s(wt(a)), s(At(i));
    },
    [a, s, i]
  ), /* @__PURE__ */ t(rt, { ...n, children: /* @__PURE__ */ t(Dt, { apiBaseUrl: a, token: i, children: /* @__PURE__ */ t(ma, { children: /* @__PURE__ */ t(ga, { language: r, children: e }) }) }) });
}
const fa = p.div`
  min-height: 1px;
  max-height: 100%;
  height: 100%;
  flex-grow: 1;
  container-name: callControlContainer;
  container-type: size;
`;
function _n(e) {
  const n = A(ze), a = A(Z), i = A(Je);
  if (!n || !a || !i)
    throw new Error("CallControlFragment must be rendered within a HostContext, ConversationContext and WorkItemContext");
  return /* @__PURE__ */ t(fa, { id: "buzzeasy-fragment-call-control", role: "region", children: /* @__PURE__ */ t(Sn, { store: $t, children: /* @__PURE__ */ t(va, { ...e, children: /* @__PURE__ */ t(ua, { children: /* @__PURE__ */ t(ca, {}) }) }) }) });
}
_n.minHeight = 300;
_n.minWidth = 400;
xn("call-control-fragment-2", "20250124.1", "3.0.12");
export {
  Ua as WebRtcSessionProvider,
  _n as default
};
//# sourceMappingURL=index.js.map
